export default [
  {
    timeStamp: "2020-03-31T11:44:41",
    email: "media@saltydingo.com.au",
    name: "Salty Dingo",
    address: "7/35 E Esplanade, Manly NSW 2095",
    category: "Advertising, Arts & Media",
    businessDescription: null,
    currentSituationDescription: null,
    operatingHours: null,
    phoneNumber: "0407474574",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://saltydingo.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/7%2F35+E+Esplanade,+Manly+NSW+2095/@-33.8001305,151.2841969,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0eb5dfd6e7:0x1a70905124aa6094!8m2!3d-33.8001305!4d151.2863856",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-salty-dingo-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-salty-dingo-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-salty-dingo-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-03-31T15:00:21",
    email: "david@smithmade.com.au",
    name: "Bird Chicken Shop",
    address: "Shop 3a/11-27 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Bird Chicken Shop is a licensed eatery and takeaway where chickens are proudly free range, antibiotic free and hormone free",
    currentSituationDescription:
      "We are operating a month dinner subscription food delivery offering healthy delicious dinner options at a affordable prices.  Just visit our website to order a family meal for one night a week  to be delivered to your door by us.",
    operatingHours: "Close Mon- Tues \nOpen Wed 11am to Sunday 8pm",
    phoneNumber: "0299760283",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.birdchickenshop.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ViztJrD6fxChaMiR6",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bird-chicken-shop-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-03-31T15:48:07",
    email: "manlyfishguts@bigpond.com.au",
    name: "Manly Fish Market",
    address: "Shop 1/25 S Steyne, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Established 25 years ago, I am still the same owner/ manager specializing in fresh and cooked seafood.",
    currentSituationDescription:
      "We are lucky to be able to trade with very little difference to how we normally operate. We just upgraded the packaging as people more likely to drive home rather than stay at the beach.",
    operatingHours:
      "Yes we are now open at 10 am (not 8am) but we are here at 9 am so if you need something just tap on the door and we are happy to serve you while setting up. Still open till 8pm, 7 days per week.",
    phoneNumber: "0299763777",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/sNsQm4ty7zT7tvYu8",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/manlyfishmarket",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fish-market-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fish-market-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fish-market-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-03-31T16:06:11",
    email: "customers@manlyhealthfoods.com.au",
    name: "Manly Health Foods",
    address: "Shop 8/23 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Manly Health Foods, owned and run by Emeli Cassell and her team, has been providing health foods, qualified health advice, practitioner and nutritional products to the Manly community for 15 years.",
    currentSituationDescription:
      "currently open as normal, limiting face to face in store contact with customers, encouraging customers to order via phone or email to listed email, so orders can be charged over the phone and picked up, offering limited delivery service. See manly health foods website for further details where customers will find our main ranges listed.",
    operatingHours: "Trading hours as normal at this stage",
    phoneNumber: "0299776972",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlyhealthfoods.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ruhKiQpBiucZmMB96",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/manlyhealthfoods/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-manly-health-foods-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-manly-health-foods-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-03-31T16:39:17",
    email: "sal@moonflowerartistry.com",
    name: "Moonflower Artistry",
    address: "300 Sydney Rd, Balgowlah NSW 2093, Australia",
    category: "Design and Architecture",
    businessDescription:
      "Moonflower Artistry is a floral studio where we make gorgeous bouquets for gifts and arrangements for the home or office.  Also available in the studio is a range of botanical beauty products, candles, products for babies, a variety of plants and artwork for the home.",
    currentSituationDescription:
      "We are offering 'contactless delivery' where we drop the flowers on the doorstep and call you when we have dropped off the flowers.  You can phone through with your order or head online & pickup from outside the shop.",
    operatingHours: "We are open Monday to Saturday - 10am - 5pm.",
    phoneNumber: "0419690835",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.moonflowerartistry.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/Moonflower+Artistry/@-33.7943674,151.2637175,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abbc608c9dbf:0x208e603a63093493!8m2!3d-33.7943674!4d151.2659062",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/moonflower__artistry/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-moonflower-artistry-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-moonflower-artistry-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-03-31T17:27:20",
    email: "connect@rubylane.com.au",
    name: "Ruby Lane Wholefoods",
    address: "Shops 1&2 200 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Our vision is to make a healthy lifestyle fun, social, inspirational and accessible. We do this through a delicious menu  the whole family can enjoy  whilst receiving service that makes you feel warm and fuzzy on the inside. Want to learn more? Once things return to normal come along to one of our monthly wellness workshops .",
    currentSituationDescription:
      "We now have a shortened takeaway menu of our crowd favourites as well as brand new website with home delivery organic fruit and veg plus healthy grocery items.  This service is available 7 days a week. We have also increased our immune boosting items like broths, soups, medicinal mushrooms and a soon to launch pate.",
    operatingHours: "7:30am-2pm 7 days",
    phoneNumber: "0299777386",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.rubylane.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/9AdqB1kVJmNM1j4w9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-ruby-lane-wholefoods-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-ruby-lane-wholefoods-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-ruby-lane-wholefoods-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T12:08:19",
    email: "deanne.bennett@lifelinenb.org.au",
    name: "Lifeline Northern Beaches",
    address: "310 Sydney Rd, Balgowlah NSW 2093, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "As a locally run not-for-profit, we’re devoted to providing critical services to the people of the Northern Beaches. These include:\n•\t24/7 Telephone Crisis Support (13 11 14)\n•\tLifeline Text 6pm-midnight, 7 days a week (0477 13 11 14)\n•\tFace to face, low cost counselling\n•\tFinancial and problem gambling counselling \n•\tSuicide Call Back service\n•\tCommunity Visitors Scheme\n•\tSupport groups (for issues such as grief & loss, depression, substance abuse and gambling)\n•\tCorporate and Community Training",
    currentSituationDescription:
      "LIfeline Northern Beaches is responding to the largest societal challenge we have seen in decades. Just in the last week, the number of callers who contacted Lifeline and wanted to talk about concerns surrounding COVID-19 has increased from 23% to 39%. We expect this to continue to rise as Australians lose opportunities to connect with each other due to the effects of COVID-19.\n\nWe are, as always, supporting people in crisis and at risk of suicide. Our services have never been so important as we support people overwhelmed by this crisis. We know that anxiety, loneliness, and sadly suicide will rise through this crisis. \n\nThe NSW Government has declared Lifeline as an essential service, which means that whatever type of lockdown applies, our staff and volunteers are able to continue to support the community by taking calls and answering texts, 24/7. We have moved our low cost clinical and financial counselling services to telephone and video support rather than face to face. We are committed to being there for the duration of this crisis.\n\nMany people are asking what they can do to help others at this time. Here are some suggestions;\n\nFirstly, we know that connecting with people saves lives. Stay in touch with people despite physical distancing and isolation requirements. We know that loneliness is a cause of significant distress and suicide. We all have a role in keeping people connected.\n\nSecondly, please make family, friends, neighbours and colleagues aware of our contact numbers – we are there for anyone feeling overwhelmed;\n\nCall 13 11 14 (24 hours a day, 7 days a week)\nText 0477 13 11 14 (6pm – midnight AEDT, 7 nights)\n\nThirdly, Lifeline Northern Beaches relies on our shops, book fairs and fundraising events to maintain our community services; our phone, text and low-cost counselling services. We have had to close our retail operations and cancel our book fair and fundraising events for the next few months. This is an economic threat to our services the like of which we have never seen. Whilst our crisis supporters are mainly volunteers, we need to be able to support them with supervision, training, tools and infrastructure. Like many retail operations we are faced with fixed costs such as rent, and that will take funds away from our frontline support. We understand that everyone is facing economic challenges but by donating, you are indirectly supporting thousands of people and actually saving lives.",
    operatingHours:
      "Call 13 11 14 (24 hours a day, 7 days a week)\nText 0477 13 11 14 (6pm – midnight AEDT, 7 nights)",
    phoneNumber: "0299495522",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.lifelinenb.org.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/TUCVkR4J4sT5u9qC6",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/lifelinenb/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-lifeline-northern-beaches-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-lifeline-northern-beaches-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T12:47:39",
    email: "hayden@haydenquinn.com.au",
    name: "The Cube Gym",
    address: "Unit E/134-140 Old Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "The Cube Gym started over 6 years ago as a small group of mates looking to keep fit and healthy in a backyard in Collaroy - since then we have grown our community and expanded our space to create what we believe is one of the best gyms in Sydney.",
    currentSituationDescription:
      "We now offer The Cube Gym at Home - video based online workouts via our app - 2 x Sessions per Day, 7 Days per Week...",
    operatingHours: "We are currently closed, all operations are based online.",
    phoneNumber: "0413559051",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.thecubegym.com.au/thecubeathome",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/thecubegym?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/thecubegym/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-cube-gym-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-cube-gym-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-cube-gym-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T13:21:41",
    email: "info@curlcurlplumbing.com.au",
    name: "Curl Curl Plumbing",
    address: "C3 1 Campbell Parade, Manly Vale NSW 2093, Australia",
    category: "Trades and Services",
    businessDescription:
      "Our business is owned and operated by long term resident and involved local, Shane Howison (His smiling face you may have seen on the trucks).  Naturally he and his team can handle any plumbing need as well as blocked sewers, drains, hotwater and general plumbing.  He and his family are proud supporters of North Curl Curl JRL and SLSC.",
    currentSituationDescription:
      "One thing we know for sure, there will be many more users of the plumbing facilities in homes around our area, and with that will come the need for emergency plumbing.  So we have geared up for this and all our technicians know the precautions they must take so that they don't jeopardise the health of you and your family.  Amongst other things that will mean that we may not shake hands as we normally do, or stand too close but what it does guarantee is that we will be available to help you cope with any plumbing crisis.  We live and work in the area, and like you, want to see everybody beat the epidemic.",
    operatingHours:
      "We are available 24/7 and will attend real crisis emergencies or make a definite appointment for problems that will need attention during normal business hours.",
    phoneNumber: "0299076077",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.curlcurlplumbing.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/Curl+Curl+Plumbing/@-33.7826109,151.271697,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa53539f658f:0x99f1f5bee4dc79f3!8m2!3d-33.7826109!4d151.2738857",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-curl-curl-plumbing-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-curl-curl-plumbing-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T14:01:15",
    email: "ashley@7thdaybrewery.com.au",
    name: "7th Day Brewery",
    address: "Unit 14/9 Powells Rd, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "7th Day Brewery operates with a combined importance of creating excellent beer and a whole hearted involvement within our local community. We rose from the dust by the help of the community through crowd funding, so we promote this idea of giving back and doing good.  This idea of local support has shaped the brand, and knowing this makes us who we are.\n\nWe are a truly independent local business, we were born on the northern beaches and remain on the northern beaches only.\n\nTake Care, from the 7th Day Brewery Team",
    currentSituationDescription:
      "We are offering takeaway from our taproom, online sales for pickup from our Taproom and local delivery to the Northern Beaches, please visit www.7thdaybrewery.com.au.",
    operatingHours:
      "Monday - Thursday : 10am - 6pm\n\nFriday : 10am - 8pm\n\nSaturday : 11am - 8pm\n\nSunday: 12pm - 6pm",
    phoneNumber: null,
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.7thdaybrewery.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/U2fLPSaLr62uXLyi6",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-7th-day-brewery-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-7th-day-brewery-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T14:36:24",
    email: "design@cre8withjaz.com.au",
    name: "CRE8withJAZ",
    address: "12/21 Sydney Rd, Manly NSW 2095, Australia",
    category: "Design and Architecture",
    businessDescription:
      "We PRINT TSHIRTS ON DEMAND + SIGNAGE.\nEverything we create is custom. \n\nONE-off orders - custom printed tees to your shop front signage.\nCasual to corporate wear, hats etc etc. \n\nWe have been in Manly for over 10years. EST 2002\n\nProviding design & print for almost every restaurant cafe to the individual in manly. Small to large events to random tees for that crazy occasion.\n\nLarge range of apparel to choose from. We provide it all and its all printed hands on inhouse by our small team. Giving you a quality niche service, quality design in a turn around time. No min. We look after small businesses individual need. We provide the latest digital full colour print technology with complete control over how, what and when each deadline is reuired is our SPECIALTY!!!  YES we even offer SAME DAY TUYRN AROUND!!!\n\nWe are located in the heart of Manly. Offering you a complete custom service to make your branding work in all areas.",
    currentSituationDescription:
      "My team flew home over night and its just me working solo. Feels like how I started the business 18 yrs ago. Doing everything on my own. HANDS ON FAST TURN AROUND PRINT FROM CONCEPT TO COMPLETION.",
    operatingHours:
      'Im working solo during these times, See our website for standard working hours. We also have an urgent 24 hour link on our home page.\nIm literally on call right now ready to take on any requests to help any one and keep everyones business open!\n\nWHO NEEDS A ground sticker printed "stay behind the line"- \nor new window signage saying WE ARE OPEN',
    phoneNumber: "0410446088",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.cre8withjaz.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/CRE8+with+JAZ+-+Design+%26+Print/@-33.7971589,151.2841049,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f4a4f540b:0xfd37abf89bf76067!8m2!3d-33.7971589!4d151.2862936",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/cre8withjaz/?hl=en",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/cre8withjaz",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-cre8withjaz-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T15:03:05",
    email: "irene@tahei.com.au",
    name: "TAHEI",
    address: "11 Market Lane, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "We wanted a platform to launch our handmade polynesian lampshades, rocket lamps and island cushions and mix in my homewares retail background to showcase Sydney's East coast classy coastal styling. Tahei is our Cook Island Tahitan family name, and also my mother's name so she's a bit freaked out to see her name up on the store, but she''ll get over it!",
    currentSituationDescription:
      "We are still open, and looking to expand the online for our clients and locals",
    operatingHours: "9.30-4pm Monday-Friday, 9-3pm Weekends",
    phoneNumber: "0447958753",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/Tahei+Decor+Manly/@-33.7974192,151.2840352,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab6d5047dd09:0xe6b37772fbf7fe9c!8m2!3d-33.7974192!4d151.2862239",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-tahei-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-tahei-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-tahei-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T15:26:12",
    email: "weifangwang@optusnet.com.au",
    name: "MBL Manly Minimarket",
    address: "77 Addison Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: "We supply milk,bread,drinks & etc to local people.",
    currentSituationDescription: "Yes, definitely! Deep impact!",
    operatingHours: "7:30am-8:00pm",
    phoneNumber: "0299775056",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/C8A62TEyaT7mHaW48",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/tahei_manly/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/irulianislands/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-mbl-minimarket-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T15:53:31",
    email: "jimmy@saltyrooster.com.au",
    name: "Salty Rooster",
    address: "73 Collingwood St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "As a household name and reputation of over 15 years we bring great tasting chicken burgers to everyone across our local community, delivered with homestyle family customer service. We are known for our strict insistence on high standards of freshness, quality and unique flavours.",
    currentSituationDescription: "LUCKY WE'RE TAKEAWAY",
    operatingHours: "Mon/Thur 9:30am - 4:30pm..... Fri/Sun 9:30am - 7:30pm",
    phoneNumber: "0299777373",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.saltyrooster.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/SaltyRooster?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-salty-rooster-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-salty-rooster-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T15:56:14",
    email: "brewpub@4pinesbeer.com.au",
    name: "4 Pines Brewing Co.",
    address: "29/43-45 E Esplanade, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "The love child of a post-surf beer and a casual conversation between a father and son – our brew pub in Manly is where 4 Pines was born. With our original microbrewery still onsite, very much alive and kicking, step up to the brewing enclosure and catch a glimpse of our brewers’ jumping from vessel to vessel, working on the origins or our small batch Keller Door beers.\n\nWe have tasty beers, delicious food and the best team in town behind the bar (now the wheel). \n\nOnline platform coming soon!",
    currentSituationDescription:
      "Used to be a fully functioning bar/resturant/pub and now offering free delivery and pick up. We are also offering ordering beer online for free",
    operatingHours:
      "7 days, 12pm - late\\nAdditional contact details:\nPick up orders - 02 9977 8352",
    phoneNumber: "0299762300",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://4pinesbeer.com.au/our-venue/brewpub-manly-brewery",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/q4V82VVgTR4uzkSM8",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/4PinesbeerManly",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-4-pines-brewing-company-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-4-pines-brewing-company-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:06:29",
    email: "info@freshiecelebrant.com",
    name: "FreshieCelebrant",
    address: "55 Wyndora Ave, Freshwater NSW 2096, Australia",
    category: "Trades and Services",
    businessDescription:
      "Local marriage celebrant, J.P. and marriage counsellor.  Intimate, meaningful ceremonies that don't cost a fortune.",
    currentSituationDescription:
      "Strict regulations have meant the cancellation or postponement of many weddings, however couples can still get married.  I have conducted two weddings recently in my courtyard at home and also on the beach headland, maintaining social distancing and adhering to the 5 people max for weddings.",
    operatingHours: "By appointment.",
    phoneNumber: "0418865402",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://freshiecelebrant.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/55+Wyndora+Ave,+Freshwater+NSW+2096/@-33.7749809,151.2850035,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aaf0bc198f61:0xa96c0ce4d46f801!8m2!3d-33.7749809!4d151.2871922",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-freshiecelebrant-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:09:57",
    email: "nigel@sigshutters.com.au",
    name: "Signature Shutters and Blinds",
    address: "48/176 S Creek Rd, Dee Why NSW 2099, Australia",
    category: "Trades and Services",
    businessDescription:
      "We offer a wide range of shade solutions indoor and outdoor with combined experience of more than 30 years, specialising in shutters and roll blinds",
    currentSituationDescription:
      "I have had to shut down one side of the business and put my sales rep on leave without pay and I have had to inject $30,000 of my personal savings into the business to keep paying bills",
    operatingHours:
      "We are on rotation to answer the phones so if you leave your details we WILL get back to you. We are still Monday to Friday anytime",
    phoneNumber: "0299828677",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://sigshutters.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/Signature+Shutters+and+Blinds/@-33.734024,151.2769973,17z/data=!3m1!4b1!4m5!3m4!1s0x6b0d557800311ce5:0xeba9e26f8719562d!8m2!3d-33.734024!4d151.279186",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-signature-shutters-and-blinds-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-signature-shutters-and-blinds-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-signature-shutters-and-blinds-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:10:14",
    email: "carolyn@2mp.com.au",
    name: "Messenger Murray Picello Pty Ltd",
    address: "Level 1/10 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "We are an accounting practice as well as a financial advisory practice. We do all things in regards to business advisory.Specialising in SME's",
    currentSituationDescription:
      "We are operating on a rostered staff system with 2 staff available at all times. We are trying to help business understand the Government stimulus packages and what is available to them and help them be on the front foot in regards to the next 6 months.",
    operatingHours: "9-5pm, Monday to Friday",
    phoneNumber: "0299778077",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.2mp.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/TA7S8Cf9pGfXtvgb7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-messenger-murray-picello-pty-ltd-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:12:55",
    email: "accounts@bennettsurfboards.com",
    name: "Bennett Surfboards Pty Ltd",
    address: "180 Harbord Rd, Brookvale NSW 2100, Australia",
    category: "Retail",
    businessDescription: null,
    currentSituationDescription: null,
    operatingHours: "Monday to Friday 8.00 AM to 5.00 PM",
    phoneNumber: "0299055157",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://bennettsurfboards.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/vpnqrNoeLzYH5PPv8",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/bennettsurfboardsaus/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bennett-surfboards-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:14:42",
    email: "greenwoodmiller@bigpond.com",
    name: "Greenwood Miller Architects",
    address: "67A Wanganella St, Balgowlah NSW 2093, Australia",
    category: "Design and Architecture",
    businessDescription:
      "Local sole trading architect with 21 years experience and a continuing passion for producing well considered & innovative architectural solutions for your new home or alterations and additions to your existing home.",
    currentSituationDescription:
      "Managing to maintain fairly regular office hours.",
    operatingHours: "9.00 am - 6.00 pm, Monday to Friday.",
    phoneNumber: "0438774051",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/iW6NbjnFjTWKU5Ey7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-greenwood-miller-architects-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:14:47",
    email: "mbarbermanly@yahoo.com.au",
    name: "M barber",
    address: "Shop 2/22A Darley Rd, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "We are a local barbershop in manly for nearly 20 years with the most loyal and passionate staff .\nIn these times a collective of people serving the people of manly as long as we are needed or able to be here for them .",
    currentSituationDescription:
      "We are operating under even more  strict health and safety and social distancing regulations than is required by Nsw health at the moment.",
    operatingHours:
      "Monday Tuesday Wednesday Friday 9-6\nThursday 9-7\nSaturday 8-4",
    phoneNumber: "0403891890",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.mbarber.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/M+Barber+Manly/@-33.7999641,151.2848807,17z/data=!4m8!1m2!2m1!1sbarber+shop!3m4!1s0x6b12ab0ec6aad1a7:0x27cc741429793737!8m2!3d-33.8000207!4d151.2872268",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-m-barber-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:19:08",
    email: "accounts@bennettsurfboards.com",
    name: "Bennett Foam Australia",
    address: "174 Harbord Rd, Brookvale NSW 2100, Australia",
    category: "Retail",
    businessDescription: "Supplier of Surfboard Blanks and Materials",
    currentSituationDescription:
      "Downfall in export orders and being able to ship and downturn in local sales",
    operatingHours: "Monday to Friday 9.00 AM - 4.30 PM",
    phoneNumber: "0299051152",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.bennettfoamaustralia.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/NYynQT6VJxayiWM69",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/bennettfoamaust/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bennett-foam-australia-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:23:20",
    email: "sean@nyagroup.com.au",
    name: "Chica Bonita",
    address: "Shop 9A, 9 The Corso, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Baja California inspired Mexican food and drinks - takeaway margaritas, tacos, burritos, and bowls",
    currentSituationDescription:
      "We’re trying to keep the dream alive and Chica Bonita food tunes rolling for all our Manly locals and regulars by providing takeaway and delivery (coming ASAP) our current takeaway menu is available online at ChicaBonita.com.au",
    operatingHours: "Mon-Sun 11am-3pm & 5:30pm-9pm",
    phoneNumber: "0299765255",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.chicabonita.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/1ThnKFMGo171koL27",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-chica-bonita-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-chica-bonita-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-chica-bonita-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:25:11",
    email: "info@thehold.com.au",
    name: "The Hold Pty Ltd",
    address: "24 Sydney Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "We offer a delicious range of gourmet burgers, craft beers & cocktails including a plant based version of every menu item for all our vegan customers.",
    currentSituationDescription:
      "The Hold bar & restaurant is now offering takeaway & delivery via phonecall (preferred) or via Deliveroo (online). Our delivery menu offers all your favourite food menu items & selected drinks which include our most popular cocktails.",
    operatingHours: "Tue - Sun 12pm - 9:30pm. Closed Mondays",
    phoneNumber: "0299772009",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://thehold.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/The+Hold/@-33.7970574,151.284462,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f4f095a19:0xcb6ecacb3856b11d!8m2!3d-33.7970619!4d151.2866507",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/theholdmanly/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/TheHoldManly",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-hold-pty-ltd-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-hold-pty-ltd-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-hold-pty-ltd-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:26:38",
    email: "blackkitchen@blackkitchen.com.au",
    name: "Black Kitchen",
    address: "Ground Floor, 10 Orchard Rd, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "Located in the heart of industrial Brookvale, Black Kitchen is serving up the best Burgers, Grab & Go Rolls, Bowls, Burritos, Coffee, Smoothies, Milkshakes, Thickshakes and Fresh Juices.",
    currentSituationDescription:
      "Black Kitchen in Brookvale is open for Takeaway, Order to Pick-up and Delivery",
    operatingHours:
      "Open for Takeaway: Monday to Friday 6:30am to 3pm. Lunchtime Deliveries: 11.30am to 2.30pm.\nFrom Wed 8th April: Opening Night Time Deliveries and Takeaway: Wednesday to Sunday: 4pm to 10pm.",
    phoneNumber: "0490062209",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.blackkitchen.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Black+Kitchen+-+formally+Food+%26+Brew/@-33.7654618,151.2696835,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab5d646531a1:0x4a3bc4647cc5873!8m2!3d-33.7654618!4d151.2718722",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/blackkitchenbrookvale/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/BlackKitchenBrookvale/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-3.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-4.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-5.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-6.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-black-kitchen-7.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:28:31",
    email: "goodtimes@sunsetsabi.com",
    name: "Sunset Sabi",
    address: "26/28 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: "Modern Japanese",
    currentSituationDescription:
      "We are open providing takeaway if our most popular items - sushi rolls, gyoza and a few of our signature dishes.",
    operatingHours: "Order online for pick up from 5:30pm Tuesday - Sunday",
    phoneNumber: "0299777461",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.sunsetsabi.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/r3cfKrHCNnZ8njw47",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-sunset-sabi-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-sunset-sabi-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-sunset-sabi-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:34:44",
    email: "bill@skaterhq.com.au",
    name: "Skater HQ",
    address: "8/750 Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Retail",
    businessDescription:
      "Providing quality skating and scooting equipment since 1991",
    currentSituationDescription:
      "Our Custom fitting Centre is temporarily closed but we are operating online and allowing hands free pick up from our warehouse in Brookvale.",
    operatingHours: "Warehouse pick up available from 10-5 weekdays",
    phoneNumber: "0286677892",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.skaterhq.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/skaterhq-brookvale?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/skaterhq/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/skaterhq",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-skater-hq-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T16:35:16",
    email: "pasta@busta.com.au",
    name: "BUSTA",
    address: "10 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: "Tasty fresh pasta, Italian classics and fun wine.",
    currentSituationDescription:
      "We’re open for takeaway fresh ready to cook at home delicious pastas and classic Italian dishes.\nOrder online and pick up from 4pm",
    operatingHours: "Tuesday - Sunday pick up from 4pm",
    phoneNumber: "0289669917",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.busta.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Busta/@-33.7952582,151.2832548,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abdf7ac8d52b:0xdb1ef5e065e18a72!8m2!3d-33.7952627!4d151.2854435",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-busta-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-busta-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-busta-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:03:22",
    email: "admin@manlyFarm.com.au",
    name: "Manly Farm - Organic Grocer",
    address: "16/17-25 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Family business providing Healthy, Organic, Nourishing food",
    currentSituationDescription:
      "We are still open 7 days 8 am to 8 pm \npick up orders have to be place at orders@manlyfarm.com.au",
    operatingHours: null,
    phoneNumber: "0299762128",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Farm+Organic+Grocer/@-33.7982598,151.2858878,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f10f3e559:0x4415402fe6abd853!8m2!3d-33.7982643!4d151.2880765",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/Manlyfarmgrocer/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-manly-farm-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-manly-farm-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:33:19",
    email: "brookvale@mwns.com.au",
    name: "Maths Words Not Squiggles",
    address: "Unit 1/698 Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Education and Childcare",
    businessDescription:
      "MWNS works with qualified teachers and experienced tutors to help our students from Kindergarten to Year 12 in both Maths & English. Our online platform is easy to join and doesn't require special software to run. We are unlocking those road blocks for our students who are not able to attend school at the moment.",
    currentSituationDescription:
      "We are offering students live online tuition for Maths & English",
    operatingHours: "Available 6 days a week Mon - Sat from 10am - 8pm",
    phoneNumber: "0291575592",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://mwns.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/9Bb4iHPye47aKnXx5",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-maths-words-not-squiggles-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-maths-words-not-squiggles-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:34:12",
    email: "contact@mppsychology.com.au",
    name: "Manly Pittwater Psychology",
    address:
      "Grand Commercial Building, Suite 4229 Level 2/834 Pittwater Rd, Dee Why NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "I provide psychological services to help clients who are dealing with anxiety, depression, adjustment to life changes, grief and loss, etc.  Please remember that in these uncertain and frightening times there is professional support available.",
    currentSituationDescription:
      "Now offering Telehealth video and phone sessions as well as face-to-face sessions",
    operatingHours: "Flexible hours Monday to Saturday",
    phoneNumber: "0418265437",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.mppsychology.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/fyjWTSF5fA3jAENx8",
        text: null,
      },
      {
        type: "Facebook",
        url:
          "https://www.facebook.com/Manly-Pittwater-Psychology-1419886498245712/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-pittwater-psychology-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:34:24",
    email: "fruitiliciouswholesale@gmail.com",
    name: "FRUITILICIOUS WHOLESALE",
    address: "13 Sydenham Rd, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "We are a wholesale fruit and vegetable company based in Brookvale, servicing many of Manly's favourite food spots .. Chica Bonita, Pure Wholefoods and Peanut Butter Jelly just to name a few. Now you to can have the same produce that many of Manly's hotspots get theirs from. We now offer next day delivery for the freshest fruit and veggies.",
    currentSituationDescription:
      "We now offer home deliveries to all the northern beaches.",
    operatingHours: "5am - 12pm Monday - Saturday",
    phoneNumber: "0488000107",
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.fruitilicious.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Chr1mx5oXCx8RDNZ7",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/fruitiliciouswholesale/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/fruitiliciouswholesale/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fruitilicious-wholesale-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:34:44",
    email: "sam@bellleisure.com.au",
    name: "Camp Blue",
    address: "3 / 20 West St Brookvale NSW 2100, Australia",
    category: "Education and Childcare",
    businessDescription:
      "Camp Blue Manly\n\nOur philosophy is to provide each camper with a unique opportunity for growth. Campers can select up to 4 of their favourite activities from a choice of between 15 and 20 camp activities. Their chosen 4 activities will be used to make their daily schedule. \n\nCamp Blue Manly is based out of Stella Maris College. Combining the incredible facilities of Stella Maris College, nearby Kerlie Park and the iconic Manly Beach, the Manly Camp Blue program is diverse, unique and never boring! \n\nEach school holiday program offers a “Special Add-On” activity, which changes each camp. This means your child will have the option of exploring something a bit different each vacation camp.",
    currentSituationDescription:
      "Camp Blue Manly can unfortunately not operate these school holidays  so NO income and no way to generate at the moment but we want to keep our staff and campers engaged with us. We will be providing FREE online live activities, challenges and a go to activity directory for parents to go to these school holidays when they are safe at home.",
    operatingHours: "N/a",
    phoneNumber: null,
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://campblue.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/camp-blue-manly?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/campblue/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/campbluesydney/",
        text: null,
      },
      {
        type: "CallToAction",
        url: "https://campblue.com.au/",
        text: "Visit Us",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-camp-blue-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-camp-blue-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:51:53",
    email: "soniac@navigatefinancial.com.au",
    name: "Navigate Financial Group",
    address: "Suite 4 2/2 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "Navigate Financial Group work with individuals and small businesses to develop a personalised financial plan to grow and protect wealth.  Our expertise is in working with you to develop personalised goals in the areas of investment, superannuation including SMSFs, retirement planning, insurance, debt management, taxation, aged care, Centrelink and estate planning.  We provide innovative and effective advice and strategies that will make a positive difference to you, your family and or your business.",
    currentSituationDescription:
      "We are available online  or by telephone to help you with questions or advice on how to manage your cashflow, superannuation and investments during this COVID 19 crisis and for the long term.",
    operatingHours: "9am - 5pm Monday to Friday",
    phoneNumber: "0299772244",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://navigatefinancial.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/4EN5XvUjGsMTtHcV8",
        text: null,
      },
      {
        type: "LinkedIn",
        url: "https://www.linkedin.com/company/navigate-financial-group",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/navigatefinancial/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-navigate-financial-group-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T17:58:55",
    email: "trish@humphreys.com.au",
    name: "H",
    address: "60-62 The Corso Manly NSW 2095",
    category: "Retail",
    businessDescription:
      "A family owned business for over 50 years serving the local\n Community with newspapers, magazines, books puzzles, toys, cards and gifts",
    currentSituationDescription: "We are open every day from 7am till 5pm",
    operatingHours: "We are open 7am till 5pm 7 days a week",
    phoneNumber: "0299771699",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.humphreys.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/tJDdMWzsep2HqFAH8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-humphreys-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T18:02:09",
    email: "info@ironbarkmanly.com.au",
    name: "Ironbark Woodfired Pizza Restaurant",
    address: "208 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Amazing Italian fare in a laid back welcoming environment",
    currentSituationDescription: "Take away and delivery",
    operatingHours: "For now the same",
    phoneNumber: "0299772255",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.ironbarkmanly.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/Ironbark-Pizza-Manly?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-ironbark-woodfired-pizza-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T18:07:42",
    email: "janicedomeney@hotmail.com",
    name: "Northern Beaches Now",
    address: "Online",
    category: "Retail",
    businessDescription:
      "I had a boutique in Darley rd, manly until November 2019, I now\nTrade at manly market place every Saturday and Sunday.",
    currentSituationDescription:
      "I am now trading online since manly market place can no longer trade.\nI can deliver items the same day to customers on the northern Beaches free of charge or can send to customers further away.",
    operatingHours: "Anytime 7 days per week",
    phoneNumber: "0414662386",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://nbnow.myshopify.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://nbnow.myshopify.com/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-northern-beaches-now-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T18:10:54",
    email: "shaun@auacams.com",
    name: "Northern Eye Security",
    address: "Queenscliff",
    category: "Trades and Services",
    businessDescription:
      "Electronic Security- usually installation sales and service but we are limiting to servicing for urgent needs during the current situation",
    currentSituationDescription: "Service to systems that can’t wait",
    operatingHours: "Mon-Fri 7:00-16:00",
    phoneNumber: "0414834823",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.auscams.com/index2.html",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/CDLLSen5nN4gmnXe9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-northern-eye-security-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T19:08:59",
    email: "accounts@purewf.com.au",
    name: "Pure Wholefoods",
    address: "5/10 Darley Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Feeding a healthy mind is as important as feeding a healthy body with the intention of love and gratitude in sustaining our strength and vitality.  We try to create the most wholesome pure meals to our community and share in the goodness.  We cater to vegan, dairy free, gluten free, free range, grass fed diets.  Let food be the medicine but way tastier. with love PURE WHOLEFOODS",
    currentSituationDescription:
      "We are doing our menu for take away, preorder and adding freshly frozen soups, dhals and curries only.  We will be delivering soon and have delivered to those having  immune issues..  We are also catering for communities such as school staff, after school care etc. clinics.",
    operatingHours:
      "As of 1 April 2020  We are open daily 8:30am - 3:00pm for pick up frozen til 3:30pm",
    phoneNumber: "0289669377",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://walter770.wixsite.com/purewholefoods",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Ln2nV6ELfLfQWcht7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-pure-wholefoods-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-pure-wholefoods-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-pure-wholefoods-3.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-pure-wholefoods-4.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T19:29:39",
    email: "shahid_zyl@hotmail.com",
    name: "Little Viet Kitchen",
    address: "5/54-68 West Esplanade, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "The best restaurant for authentic Vietnamese street food in Manly NSW.\n\nOur menu is the perfect way to explore the many wonderful flavours of Vietnamese cuisine.",
    currentSituationDescription: "Offering take away and delivery",
    operatingHours: "Monday - Sunday 11:30am to 9pm",
    phoneNumber: "0289669755",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.littlevietkitchen.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/CVD3o9Wsgb7xEij1A",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-little-viet-kitchen-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-little-viet-kitchen-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T19:50:44",
    email: "tom@blaekstore.com",
    name: "BLAEK Store",
    address: "210 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "‘Black’ Store. A thoughtful retail space offering sustainable, ethical & organic clothing, homewares & daily essentials by mindful designers from around the world.\n\nBLAEK Store came about because my wife Nikki and I always had a passion for living a sustainable lifestyle. You know, the type where the environment and the world that remains after you is your inspiration that dictates all conversations and decisions in life? We were always into sustainable fashion and while the sustainable (organic, local etc) food industry started to become super mainstream we noticed that fashion was lagging and wanted to do something about it.\n\nWe found ourselves not shopping even when we really needed a new t-shirt for example because, not only did we not have the time to trawl the internet for responsible brands all we could find was pretty daggy 'one size fits all' type sustainable and organic options. There was so much green-washing where people were publishing intentionally misleading information about their sustainable commitment or using buzz words in order to sound cool and like they care but without actually doing either. It was all just so hard and we didn't understand why there was a lack of multi-brand, sustainable stores selling good clothing, homewares and everyday essentials for men and women. Sooooo we started our own and what started as a pop-up store in Freshwater quickly morphed into a fully fledged business that is now 10 months old at 210 Pittwater Road, Manly and online at blaekstore.com. \n\nWe brought brands like Nudie Jeans Co. back to Manly which, not many people will know but was the very first place Nudie Jeans Co. was sold in Australia and it began to attract beautiful customers who were buying for the right reasons. We're proud of our close relationship with Nudie Jeans Co. who are doing huge things in sustainable denim.",
    currentSituationDescription:
      "We have had to close our physical store and focus on reaching our customers digitally. We are offering free same day delivery to Manly residents who are unable to leave the house, free shipping and free virtual hugs!",
    operatingHours:
      "We will open for appointments if you need and aside form that are operating online or over the phone.",
    phoneNumber: "0439359515",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.blaekstore.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/blaekstore?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/blaek.store/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/blaekstore/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-blaek-store-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-blaek-store-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-blaek-store-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T20:13:00",
    email: "jill@bodyandbalance.com.au",
    name: "Body and Balance Fitness and Wellness",
    address: "66 Innes Rd, Manly Vale NSW 2093, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      'Jill Healy-Quintard of Body and Balance Fitness and Wellness, Australia is passionate about Fitness and Wellness, having  40  years industry history, a Top 3 Award Nominee in the Australian Fitness Awards 2020, author and thought leader.\n"I believe in Balance of Life, Keeping the Body and Mind Fit and Moving. My hashtags include #mindbody #fitnessmotivation #wellnessmotivation #anytimeanywhere #doitwithme #intentions #proage #womenempowerment #livelovelaugh #liftyourvibration #divinefeminine #thisismeseries #wearefitnessaustralia #manlybeach\n My mantras are:\n“Shape Your Body, Shape Your Mind”.\n “Say it, see it, feel it, make it happen.” And you will make it happen',
    currentSituationDescription:
      "My IT husband (also out of work) and I have quickly recorded, edited and put up online through my website (www.bodyandbalance.com.au) pre-recorded Fitness and Wellness classes. These include my registered methods such as YogaPilates Fusion, BodyBarre, Meditation and Breathing Techniques that will aid Brain Health, overcome depression and anxiety, plus naturally increase fitness levels. We are also running LIVE classes using ZOOM.......called we are 'Screamin' for Streaming' Classes.  Currently I am Top 3 in the 2020 Group Fitness Awards with Fitness Australia. I offer 40 years of passion and dedication to Fitness and Wellness having taught all ages and fitness levels.",
    operatingHours:
      "LIVE Streamed Classes are Monday-Saturday (booking is required) or anytime between 6:00am-8:00pm daily for pre-recorded classes \nhttps://bodyandbalance.com.au/classes-online/ \nMore details of classes via the ZOOM link on www.bodyandbalance.com.au",
    phoneNumber: "0412422868",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://bodyandbalance.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/b8be7CbWU38kGVRH8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-body-and-balance-fitness-and-wellness-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-body-and-balance-fitness-and-wellness-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T20:21:37",
    email: "justin@jmacgraphics.com.au",
    name: "Jmac Graphics Pty Ltd",
    address: "Unit 8A 3/9 Kenneth Rd, Manly Vale NSW 2093",
    category: "Design and Architecture",
    businessDescription:
      "We combine Graphic Design with Signage meaning a one stop shop for all your graphic needs.",
    currentSituationDescription: "We are open and supporting our customers.",
    operatingHours:
      "We are open 5 days a week from 8.30am to 4.30pm during this time",
    phoneNumber: "0299489900",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://jmacgraphics.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/gSb1UcXhfyzbBtGw6",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/jmacgraphics/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/jmacgraphicsPtyLtd/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-jmac-graphics-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T20:24:05",
    email: "kieran@supgearaustralia.com",
    name: "SUP Gear Australia",
    address: "Unit 1/384 Pittwater Rd, North Manly NSW 2100, Australia",
    category: "Travel, Adventure and Tourism",
    businessDescription: null,
    currentSituationDescription:
      "These are uncertain and scary times, and while we don’t know what the future holds, as your local community SUP shop, we want to be there to support you as much as we can.\n\nWe support the message to ‘Stay Home‘ and therefore don’t expect you to visit us in store if you don’t want to. We have updated our website so that ALL available stock (including ALL SUPs) are available to purchase online.\n\nWe recognise that choosing a stand-up paddleboard is a process that is worth investing time into, so if you’re currently in the ‘research phase’ and not ready to buy just yet, why not give us a call or email (with your number), and we will call you back on FaceTime to talk you through our range of boards, paddles and accessories, and discuss the right options for you (with no pressure to buy!)\n\nWe truly believe that activities like stand-up paddleboarding and SUP Surf are becoming vital in this crisis to support everyones physical and mental wellbeing. SUP is an activity that you can do alone, that connects you with nature, and can be both a work-out as well as soothing for the soul.\nIf you feel the same, get in touch and we’ll kit you out with everything you will need during this challenging time.\n\nWe hope to hear from you soon!\n\nKieran, Catherine, Ella, Kevin & the rest of the team at SGA",
    operatingHours:
      "If you would like to visit the store in person – we are still open 7 Days a week.\nMonday to Saturday is 10am to 5pm & Sunday is 11am to 4pm. We are limiting store access to one household/ person at a time and we invite you to call in advance to let us know what time and day you wish to attend so that we can hold that time slot for you and host you for a private appointment.\n\nIf you decide to proceed with a SUP purchase, we will deliver your board by courier (if in Australia) or one of our store team will personally drive it to your home address if you’re in the Sydney Metro area. We will let you know when the board is at your doorstep so you can immediately bring it in, without contact or interaction. We always make sure that products are thoroughly cleaned before they are packed for shipping and we will be taking extra care over this.",
    phoneNumber: "0299393939",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.supgearaustralia.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/SUPGearAustralia?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-sup-gear-australia-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T21:06:11",
    email: "amy@iconhomes.com.au",
    name: "Icon Homes",
    address: "226 Warringah Rd, Beacon Hill NSW 2100",
    category: "Trades and Services",
    businessDescription:
      "Icon Homes is your local Northern Beaches Knock Down Rebuild Specialist, now with two display homes on the Beaches. Our team understand that you love where you live and will work with you to deliver your custom designed dream home at no extra cost.",
    currentSituationDescription:
      "While our Display Homes are now closed, we can still take people through for private tours. Our building sites are still open and our whole team are still working - just from home.",
    operatingHours: null,
    phoneNumber: "1800694266",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.iconhomes.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/11oegELHFCs1GvxDA",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/icon_homes/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/IconhomesNSW",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-icon-homes-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T21:23:06",
    email: "julie@juliecrespel.com",
    name: "Julie Crespel Photography",
    address: "P.O. Box 4053, North Curl Curl, 2099",
    category: "Advertising, Arts & Media",
    businessDescription: null,
    currentSituationDescription: null,
    operatingHours: "Monday- Sunday sunrise-sunset",
    phoneNumber: "0417488168",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.juliecrespel.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/x8dEeDpfJKVdLeT98",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://instagram.com/juliecrespelphotography/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/juliecrespelphotography/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-julie-crespel-photography-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T21:57:02",
    email: "patrick@bunbarburgers.com",
    name: "BunBar Burgers",
    address: "Shop 1A/2-8 Darley Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "BunBar Burgers is flipping the traditional concept of Burger buns on their head, with an innovative offering of Soft, Grilled Rice, Lettuce and Falafel buns with a range of fillings such as Grilled Beef, 20-Hour Beef Brisket, Grilled Chicken and more, plus a range of delicious vegan options!",
    currentSituationDescription:
      "We have moved totally to a take-away and delivery offering and worked behind the scenes to create our own mobile app on the iOS and Android App stores so our customers could order directly with us from their mobile phone and collect their food in a 'contactless' manner.",
    operatingHours:
      "Thursday: 5-9PM\nFriday/Saturday: 12-2PM, 5-9PM\nSunday: 12-2PM,5-8PM\\nYou can also order through our new app",
    phoneNumber: "0412335599",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.bunbarburgers.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/BunBar?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bunbar-burgers-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T22:56:00",
    email: "gerry@vimaco.com.au",
    name: "Vimaco",
    address: "12 Clontarf St, Seaforth NSW 2092",
    category: "Advertising, Arts & Media",
    businessDescription:
      "We turn Web Traffic into Foot Traffic, using our Restaurant Sales Funnel. This is an automated marketing system that consistently gets new customers and converts them into loyal fans. Now you can focus on serving your customers.",
    currentSituationDescription:
      "Vimaco provides Social Media Marketing for Restaurants. Since the shutdown, we now offer a FREE Restaurant Rewards Program to attract new customers for takeaway meals and build a database to get repeat customers.",
    operatingHours:
      "Book For a Free Strategy Call To Help Your Restaurant Survive This Crisis.\nClick the link below and select a time that is most convenient for you.\nhttps://calendly.com/restaurantsalesfunnel",
    phoneNumber: "0417414930",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://vimaco.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/tFufQ9uTNcSrNQ9q6",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/sydneydinersvip/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/vimaco.au",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-vimaco-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-01T23:10:34",
    email: "jipang.manly@gmail.com",
    name: "Jipang-japanese home style kitchen-",
    address: "Shop 9 37/39 The Corso, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "We have been proudly serving hearty meals and supported since 1993. One of oldest restaurant in manly!!",
    currentSituationDescription: "We do takeaway and home delivery service.",
    operatingHours: "Monday to Sunday. \n11:30-20:00",
    phoneNumber: "0299774436",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://jipang-manly.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/xeuUJLTpuTwE8x238",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/jipang.manly/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-jipang-japanese-home-style-kitchen-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T07:18:15",
    email: "us@hemingwaysmanly.com.au",
    name: "Hemingway's Manly",
    address: "48 N Steyne, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "We at Hemingway’s Manly embrace the adventure and the love of life in a relaxed beach-front atmosphere. Come and enjoy breakfast, lunch or dinner with us.\n\nEnjoy Manly the Hemingway’s way.",
    currentSituationDescription:
      "Hemingway offers the best coffee on Manly. Takeaway menu for food and coffee",
    operatingHours:
      "Monday: Closed\nTuesday: 7amto2pm\nWednesday: 7amto2pm\nThursday: 7amto2pm\nFriday: 7amto2pm\nSaturday: 7amto2pm\nSunday: 7amto2pm",
    phoneNumber: "0299763030",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://hemingwaysmanly.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/MH67mJm7MZp4zapg6",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/hemingwaysmanly/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/hemingwaysmanly/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-hemingways-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-hemingways-manly-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-hemingways-manly-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T09:53:31",
    email: "phung73@hotmail.com",
    name: "Patploy Thai restaurant",
    address: "26A Darley Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: "Delicious Food & Good  Valuable  for local people",
    currentSituationDescription:
      "Dinner Special Tuesday & Wednesday night only $ 11.90 / Lunch Special from Thursday-Sunday only $ 11.90",
    operatingHours:
      "Dinner : Monday-Sunday 5.00 pm- 21.30 pm Lunch:Thursday- Sunday11.30 am- 14.00 pm",
    phoneNumber: "0299775012",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://patploythaimanly.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/GWs1pwBUg6iUVZmC9",
        text: null,
      },
      {
        type: "Facebook",
        url:
          "https://www.facebook.com/pages/category/Thai-Restaurant/Patploy-Thai-Restaurant-1435112603400800/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-patploy-thai-restaurant-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-patploy-thai-restaurant-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T10:01:38",
    email: "krystyna@manlysocial.com",
    name: "Manly Social",
    address: "Balgowlah",
    category: "Trades and Services",
    businessDescription:
      "We're delivering an online platform to enable Northern Beaches locals to stay socially connected in times of spatial distancing and lockdown.  We do this through content, webinars, podcasts and more around topics of community interest - Mental Health, Health & Well Being, Family, Entertainment, Food and Drink and much more.",
    currentSituationDescription:
      "We are reinvigorating Manly Social to become a support and engagement network for Northern Beaches locals and businesses through the Corona Crisis",
    operatingHours: "24x7",
    phoneNumber: "0418240040",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.manlysocial.com/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-social-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-social-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T10:50:14",
    email: "kit@coyaonline.com",
    name: "COYA",
    address: "63/61 Carawa Rd, Cromer NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      'Our food is inspired by the rich diversity of fresh Australian produce and influenced by the subtle flavours of the Middle East. To present simple modern Australian cuisine with a Middle Eastern twist, exploring unique, interesting flavours. "COYA in the box" allows you to enjoy top quality restaurant food at your own home.',
    currentSituationDescription:
      "It has affected us hugely, we switch from dine in only to just offering pick-up only. We have a small pick up menu.",
    operatingHours: "Tuesday to Sunday. 4pm - 8pm",
    phoneNumber: "0299817053",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.coyacromer.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Js6PLhAbt6LfxrFU9",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/coyacromer/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/coyacromer",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-coya-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-coya-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T11:36:57",
    email: "office@poschandsilva.com.ah",
    name: "Posch & Silva Moving Solutions",
    address: "99 South Creek Rd, Cromer NSW 2099",
    category: "Trades and Services",
    businessDescription: "Tailored moving solutions at an affordable price.",
    currentSituationDescription:
      "We have cancelled all our packing and unpacking jobs due to health concerns. We are still offering removals (both commercial and domestic) as well as storage options. All our staff have been wearing masks and gloves whilst doing the moves.",
    operatingHours: "Monday to Saturday 7am to 5pm.",
    phoneNumber: "1300668363",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.poschandsilva.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Tt7HPJAU1G2FK9pZ9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-posch-silva-moving-solutions-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T12:20:55",
    email: "yvette@maglianeratours.com",
    name: "Maglia Nera Cycling Tours",
    address: "PO Box 207, Freshwater NSW 2096",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "Maglia Nera Cycling Tours runs divine tours in divine locations around the world. \nWe aim to provide you with an unforgettable experience in amazing places where you can ride your bike. \nWe have a fully flexible approach to our tours when trying to meet guests budgets without compromising the quality of our service.\nOur partners Pinarello, Castelli, MOSTBike and Garmin, to name a few, allow you to experience top-end quality products whilst touring with us.",
    currentSituationDescription:
      "All of our tours from March to August in both Australia and Europe have been cancelled. This has left zero income for the business and 11 contract staff with no work. \nWe are running a 'Take Care' program now where we help people with resources to keep Physically and Mentally healthy. Whilst this does not make us any money, we feel strongly about everyone taking care of each other at this very point in time.",
    operatingHours: "No change",
    phoneNumber: "0404679146",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://maglianeratours.com/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/maglianeratours",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-maglia-nera-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-maglia-nera-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-maglia-nera-3.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-maglia-nera-4.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T12:54:36",
    email: "dining@pilu.com.au",
    name: "Pilu at Freshwater",
    address: "Moore Rd, Freshwater NSW 2096, Australia",
    category: "Food and Drink",
    businessDescription:
      "Pilu at Freshwater is a fine dining restaurant which has been operating on Freshwater Beach for 15 years - we offer great Italian food in a spectacular setting.  We also operate Pilu Baretto, adjacent to the main restaurant.  Here we offer great coffee, easy meals and pastries - we operate as a wine bar Friday - Sunday during daylight savings.",
    currentSituationDescription:
      "We are now offering take-away from Wednesday - Sunday from 5-7.30pm.  Pilu Baretto is open for take away coffee and meals from 7am-1pm daily.",
    operatingHours:
      "Pilu at Freshwater - Wednesday - Sunday for take-away 5-7.30pm.  Pilu Baretto 7am-1pm for take-away.",
    phoneNumber: "0299383331",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://pilu.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/Piluatfreshwater?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/pilurestaurant/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/Piluatfreshwater/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-pilu-at-freshwater-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-pilu-at-freshwater-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T13:13:31",
    email: "sales@bikefactory.com.au",
    name: "Brookvale Bike Factory",
    address: "12/750 Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Retail",
    businessDescription:
      "We provide sales, advice, service and repair of bicycles and accessories with information and products tailored to local riders and conditions!",
    currentSituationDescription:
      "We are operating as usual! Additionally, we offer a drive through service for customer wishing to stay in their car!",
    operatingHours:
      "Monday-Wednesday: 9am-6pm, Thursday: 9am-7pm, Friday: 9am-6pm, Saturday: 9am-5pm, Sunday: 10am-4pm",
    phoneNumber: "0280849914",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.bikefactory.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Brookvale+Bike+Factory/@-33.7614791,151.2756958,15z/data=!4m2!3m1!1s0x0:0x87d46d6ca11337da?sa=X&ved=2ahUKEwi17pKdyMvoAhVvIbcAHbrJDY8Q_BIwDHoECA8QCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-brookvale-bike-factory-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-brookvale-bike-factory-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T13:39:15",
    email: "west@siloespresso.com",
    name: "Silo West",
    address: "Shop 6/54 West Esplanade, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Silo West is the young brother of Silo Espresso, delivering Silo coffee and a bit of Brazilian taste meals and serving with smile.",
    currentSituationDescription:
      "We still offering 100% of our menu, lost all dinning serving, but online with UBEREATS, DELIVEROO, DOordash and HEY YOU. Offering free deliver fee for orders made out of the phone and deliver around the block. 0406571683",
    operatingHours:
      "Mon to Friday 5:30 to 17:00, Saturday and Sunday from 6:00 to 17:00",
    phoneNumber: "0406571683",
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.siloespresso.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/silowestespresso?share",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/siloespresso",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-silo-west-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T13:51:23",
    email: "warriewood@code5.com.au",
    name: "Code 5",
    address: "1/98 Old Pittwater Rd, Brookvale NSW 2100",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Our vision is to help more then 30.000 people to lose over 5kg and keep it off forever",
    currentSituationDescription:
      "We had to shut our gym but everything is online now so we can still keep your members accountable, we are offering daily body weight workouts that you can do anytime and anywhere, several virtual classes daily, meal plans, getting twice contacted from your coach to set your weekly goals and check ins to keep you accountable.\nCome and try it out for a 7 DAY FREE TRIAL and click the link     bit.ly/code5online7daysfree",
    operatingHours: "Monday - Sunday",
    phoneNumber: "0410271292",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.code5.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Code+5+Fitness+Brookvale/@-33.7624739,151.263449,15z/data=!4m2!3m1!1s0x0:0x457849446420b622?sa=X&ved=2ahUKEwj9sYTDtcvoAhVSmuYKHREZCqkQ_BIwDXoECBAQCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-code-5-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-code-5-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T14:03:26",
    email: "jake@rowe-partners.com.au",
    name: "Rowe Partners Real Estate",
    address: "Shop 1, 22 Darley Rd, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "A boutique real estate business built on experience and trust, with local knowledge and a strong track record across all price levels.\nRowe Partners Real Estate has been created to ensure when you partner with us to sell or lease your home or investment property, your property will be given the time, consideration and attention to detail it so thoroughly deserves.",
    currentSituationDescription:
      "Whilst the Federal Government has now introduced new measures in terms of how properties can be shown or sold, we are adapting to the new landscape by being positive and creative. We have adopted new technology such as 3D tours of our properties, inspections at scheduled viewing times by appointment, and running online auctions where people can bid from their own home and sign documentation on an iPad.\n \nHaving a small boutique office with fewer staff has meant that we are operational and working as a team every day whilst maintaining our social distancing with clients and colleagues. Hand sanitiser and masks are readily available for our staff when required.",
    operatingHours: null,
    phoneNumber: "0414612546",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://rowe-partners.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/YdP1WMthwriKozM37",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/rowepartnersrealestate/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/rowepartnersrealestate",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-rowe-partners-real-estate-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T14:10:13",
    email: "silo@siloespresso.com",
    name: "Silo Espresso",
    address: "17 Sydney Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Quick local roasted coffee and bites served with a smile",
    currentSituationDescription:
      "Take away only but now you can order and pay ahead with Hey You (online app).",
    operatingHours:
      "Monday to Friday 5.45 to 5\nSaturday 6 to 5\nSunday 7 to 5",
    phoneNumber: null,
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.siloespresso.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Ltmg3KfbrVRGfq8h8",
        text: null,
      },
      {
        type: "CallToAction",
        url:
          "https://play.google.com/store/apps/details?hl=en&id=com.beattheq.android",
        text: "Hey You on Google Play",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-silo-espresso-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T14:10:51",
    email: "marinecouriersaustralia@gmail.com",
    name: "MARINE COURIERS",
    address: "East esplanade Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "For the love of \nSaltwater Sunshine and Manly\nWe are here to provide a service to residents businesses and others in need of product transport. Point to point secure collections and deliveries \nAnd most of our usual marine work",
    currentSituationDescription:
      "We have launched marine couriers as a point to point delivery and collection service based in manly \nBoat relocations and maintenance are still available where permitted and deemed safe",
    operatingHours:
      "Feel free to call anytime and if someone is awake we will get straight back to you.\nChris 0427424481\nJason 0405780482\nMarinecouriers.com.au",
    phoneNumber: "0427424481",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://marinecouriers.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/mSSZFUtAziMEfQpd7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-marine-couriers-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T15:04:39",
    email: "mg@manlysurfschool.com",
    name: "Manly Surf School",
    address: "93/95 N Steyne, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Surf Lessons from at Manly Beach, Long Reef, Collaroy, Palm Beach . Beginner, Intermediate, Advanced . Teaching since 1983. Coaching World Champions, Australian Champions , Nsw Champions and stoked recreational surfers of all ages and ability",
    currentSituationDescription:
      "Private Lessons everyday from Sunrise to Sunset",
    operatingHours:
      "Sunrise to Sunset\\nYou may also contact us though this number: 02 9932 7000",
    phoneNumber: "0418717313",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.manlysurfschool.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Surf+School/@-33.7909841,151.2873408,15z/data=!4m2!3m1!1s0x0:0xb2e03dea7a563ba9?sa=X&ved=2ahUKEwjpsZW6uMvoAhXh8XMBHdIrDJ8Q_BIwDXoECBgQCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-surf-school-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-surf-school-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T16:40:17",
    email: "info@buckandsimple.com",
    name: "buck&simple Architects",
    address: "2/7A Wentworth St, Manly NSW 2095, Australia",
    category: "Design and Architecture",
    businessDescription:
      "We believe in the inherent beauty of simplicity, great design is timeless. We are a creative team of Architects dedicated to bespoke outcomes.\n\nUnique. Adaptive. Enduring.\n\nOur process focuses on the craft; harnessing opportunities of site, brief and the client by delivering uniquely tailored, environmentally sustainable solutions of a timeless nature. Our experience allows us to conceptualise and execute bespoke designs suited to the needs of the client with precision and avidity.",
    currentSituationDescription:
      "With our staff setup and working remotely we have the capacity to continue to fully meet the demands of all projects.",
    operatingHours: null,
    phoneNumber: "0415770383",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://buckandsimple.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/6tkboZgHsmW9E4aN7",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/buckandsimple",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/buckandsimple-343691272409961/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bucksimple-architects-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T17:54:58",
    email: "office@manlybeachhealthclub.com",
    name: "Manly Beach Health Club",
    address: "2 Raglan St, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "We are your local one stop fitness shop.\nOffering 24hr access, beachfront classes, rooftop yoga and top qualified PTs and exercise physiologists",
    currentSituationDescription:
      "We are offering  live stream online classes, On demand pre recorded classes and 1 on 1 outdoor PT",
    operatingHours:
      "We are online and on demand. Live classes are between  6am and 8pm Mon - Sunday",
    phoneNumber: "0413651006",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.manlybeachhealthclub.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Beach+Health+Club/@-33.7955556,151.2869444,15z/data=!4m2!3m1!1s0x0:0x738cc4ab1b428113?sa=X&ved=2ahUKEwi359fPwcvoAhUMfX0KHYdcBrkQ_BIwDXoECBYQCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-beach-health-club-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-beach-health-club-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-beach-health-club-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T20:29:33",
    email: "raj@nineyardscoffee.com.au",
    name: "Nine yards coffee",
    address: "11 Green St, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "Roastery cafe located on Brookvale. Coffee is roasted on site. We have a full kitchen & a variety of coffee beans & brew equipment to choose from,",
    currentSituationDescription:
      "Our Roastery cafe is now open for take away, delivery via Uber eats & online for coffee beans,",
    operatingHours: "Weekdays 6:30am - 2pm, Saturday 7am - 12:30",
    phoneNumber: "0284130837",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.nineyardscoffee.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ZT97EKDLqMfY4ALF6",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/nineyardscoffee/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/nineyardscoffeeroasters/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-nine-yards-coffee-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-nine-yards-coffee-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-02T22:02:17",
    email: "ryan.laguna85@gmail.com",
    name: "Lindus Dry Cleaners Manly",
    address: "40 Belgrave St, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "We are a local family business. Steve is the small business owner and has lived in Sydney all his life. He’s been operating in Manly for 7+ years. We are the best dry cleaners in the area. We specialise in your bespoke and special garments. Our speciality are doonas, wedding dresses, suits and leather. We also do minor alterations and we take pride in everything we do. Come say hello to Steve and his team. Say hello to our little bully mascot, Bailey!",
    currentSituationDescription:
      "Due to restrictions and social distancing our business has been severely impacted. Our customers don’t know that we’re essential services and we are still open. We offer dry cleaning and laundry services. We are still operating and we even have a 24/7 redbox for drop offs and collections.",
    operatingHours:
      "We are open from 7am to 5pm Monday to Saturday and closed on Sunday. We have 24/7 drop off and pick up facilities via our Redbox!",
    phoneNumber: "0414870525",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.lindusdrycleaners.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/qayPp5SNHMiyVdpN7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-lindus-dry-cleaners-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-lindus-dry-cleaners-manly-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T08:44:55",
    email: "carly@infinitybakery.com.au",
    name: "Infinity Bakery",
    address: "Shop 3/15a Market Pl, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Infinity bakery manly  provides the local community with wholesome and delicious baked goods. Making great bread, pastries and pies is in our bones. All our sourdoughs are made with local produce and organic ingredients. \nOur pastries are baked fresh every morning, also our muesli, jam, butter is all made in house. \nWe source our coffee beans from Gabriel Coffee  Roasters \nBe sure to get friendly Quick service \nWe keep it simple and delicious .",
    currentSituationDescription:
      "Takeaway Bakery \nOur menu has changed the same",
    operatingHours:
      "Monday 6am - 1pm \nTuesday 6am - 1pm \nWednesday 6am - 1pm \nThursday 6am - 1pm \nFriday 6am 1pm \nSaturday 6 am - 2pm \nSunday 7am - 1pm",
    phoneNumber: "0299774340",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.infinitybakery.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/8poMRXwZ1Q3P3L9w5",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/infinitybakery/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-infinity-bakery-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-infinity-bakery-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T11:02:46",
    email: "adrian@adrianholmeslaw.com",
    name: "Adrian Holmes Law",
    address: "18/23 Whistler St Manly NSW 2095 Australia",
    category: "Trades and Services",
    businessDescription:
      "In a period of financial and physical constraints my virtual lawyer solution provides responsive legal advice for the problems and prospects that require legal assistance at a manageable cost.",
    currentSituationDescription:
      "I am operating by mobile telephone and email.",
    operatingHours: "Available 7 days",
    phoneNumber: "0417680934",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://adrianholmeslaw.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/TKnkQtGbDdjRMcEM8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-adrian-holmes-law-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T12:35:06",
    email: "nicolas@worldconnections.com.au",
    name: "World Travel Connections Pty Ltd",
    address: "Suite 2/53 Ethel St, Seaforth NSW 2092, Australia",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "We are a small boutique full service travel agency focused on personalised and high standard customer service.\n\nIn addition we offer Migration Services for people with Australian visa issues in or out of Australia",
    currentSituationDescription:
      "Covid-19 affects business revenue drastically with limitted enquiries at the moment",
    operatingHours:
      "9 to 7 Monday to Friday 9 to 4 Saturday and on appointment Sunday and after hours",
    phoneNumber: "0299498366",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.worldconnections.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/b61d8jwrCSVnHgfx8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-world-travel-connections-pty-ltd-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T12:54:57",
    email: "info@divesydney.com.au",
    name: "Dive Centre Manly",
    address: "10 Belgrave St, Manly NSW 2095, Australia",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "Dive Centre Manly is situated closest to Sydney's best dive sites. Being a multi-award winning PADI 5 Star Instructor training facility, we offer a complete range of dive courses from Discover Scuba to Instructor level and beyond - including Sydney's most talked about Learn to Dive course. \nWe have Learn to Dive programs taught by some of the most experienced dive staff in Australia including a PADI Course Director, Staff Instructors, Master Scuba Diver Trainers and Divemasters. \nWe offer our local community the chance to keep on top of their fitness and mental health during this current time, where it is safe to dive underwater.",
    currentSituationDescription:
      "Due to COVID-19, Dive Centre Manly have temporarily closed their store on Belgrave Street, Manly and are fully operating out of their Training Centre in Manly Vale. The following is available from the Training Centre: air fills, tank hire, dive gear hire, private courses, dive gear servicing and maintenance. Our available courses are now for private tuition to abide by the two-person max rule currently in place in NSW.",
    operatingHours: "Mon-Sun 8:30 AM - 5 PM",
    phoneNumber: "0299774355",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.divesydney.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/D1%2F1+Campbell+Parade,+Manly+Vale+NSW+2093/@-33.7826109,151.271697,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa53539f658f:0xce1a388ad5cf6064!8m2!3d-33.7826109!4d151.2738857",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-dive-centre-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-dive-centre-manly-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T14:13:31",
    email: "mark.griffiths@raywhite.com",
    name: "Ray White Seaforth",
    address: "48a Ethel St, Seaforth NSW 2092, Australia",
    category: "Trades and Services",
    businessDescription:
      "We are a local real estate business, providing the services of property sales, commercial property sales, development sties & off-the-plan sales, we provide residential & commercial property management  services",
    currentSituationDescription:
      "We obviously can't do our normal open for inspections or auctions, otherwise we are open for business!",
    operatingHours: "Our office is available by appointment only",
    phoneNumber: "0422444367",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://raywhiteseaforth.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Ray+White+Seaforth/@-33.797521,151.250861,15z/data=!4m5!3m4!1s0x0:0x739b1dc9f1507d94!8m2!3d-33.797521!4d151.250861",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-ray-white-seaforth-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-03T15:20:15",
    email: "sam.rana@brookvaleautocentre.com.au",
    name: "Brookvale Auto Centre Pty Ltd",
    address: "U43/49 Mitchell Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription: "Vehicle servicing, repairs, registrations...",
    currentSituationDescription: null,
    operatingHours: null,
    phoneNumber: "0299071828",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://brookvaleautocentre.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Brookvale+Auto+Centre/@-33.7666439,151.2747991,15z/data=!4m2!3m1!1s0x0:0xe2d7e8ca420fcb9e?sa=X&ved=2ahUKEwiHrNPYvdPoAhXBbX0KHYtNC2EQ_BIwDHoECBoQCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-brookvale-auto-centre-pty-ltd-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-04T07:21:31",
    email: "sunchongjing@163.com",
    name: "Trapani cafe",
    address: "535 Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Food and Drink",
    businessDescription:
      "Trapani cafe is a venue that welcomes the whole community like family. Trapani cafe serve breakfast/lunch/sandwiches &wraps/burgers &chips/ homemade dumplings and Campos coffee & beverage by Sophie and her family since 2013 in seaforth.",
    currentSituationDescription:
      "We offering take away, and there is an updated menu for take away.",
    operatingHours:
      "5:45am to 3pm Mon-Fri. 6:45am to 2pm Sat. 6:45am to 12pm Sun.",
    phoneNumber: "0299489899",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Trapani+cafe/@-33.7967436,151.2499001,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abc1ec123131:0x6a0d8f9c9bfb7173!8m2!3d-33.7967436!4d151.2520888",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/trapani_espresso",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-trapani-cafe-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-04T13:44:20",
    email: "warringah@topjuice.com.au",
    name: "Top Juice WARRINGAH MALL",
    address: "Shop 1528A Condamine St, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "We at Top Juice are a all natural premium juice bar, we select the freshest vegetables and the most exotic and mouth- watering fruit, creating the DELICIOUS juices, smoothies, protein shakes and superfood shots. \n\nWe are a Australian business and all our produce we use to juice with comes from local growers and farmers.",
    currentSituationDescription:
      "Top Juice has now launched a home delivery service of fresh fruit and veggies box which you can order on our website www.topjuice.com.au\nInside the box you get a variety of fresh fruit and veggies with contactless delivery\n\nWe also have an instore offer at Top Juice Warringah - 2 Fruit or Veggie Juices for $10.\n\nWe sell immunity shots instore: Ginger and Wheatgrass.\n\nEverything is take away at Top Juice Warringah and we prefer contactless payment via card.\n\nIf you do not want to go instore and order we also have delivery options such as UberEats.",
    operatingHours: "7am-3pm",
    phoneNumber: "0415262079",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.topjuice.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/b3MYYhf18MaGgP66A",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-top-juice-warringah-mall-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-04T14:20:01",
    email: "nerinasbellezza@gmail.com",
    name: "Nerina's Bellezza Face and Body",
    address: "Shop 18/567 Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "We are a mother daughter family run beauty salon, and Nerina is considered an institution in the beauty industry as the salon has been running for over 35 years! Our point of difference as that we have long standing experienced and professional staff, and we treat and look after our clients like family.  We're adapting and navigating ways to do that from your home.",
    currentSituationDescription:
      "We are unable to operate for beauty services, but we are operating as a retail store for skin care with currently a sale storewide, and we're offering video consults for skin care advice and \"how to's\" on our social media, for how to do your beauty treatments at home. We do skin care pick up at the salon,  and free contactless product delivery.",
    operatingHours: "Monday - Saturday, 10am-4pm",
    phoneNumber: "0299491687",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.nerinasbellezza.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/kGT2mBEWdhNmsuSMA",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/nerinasbellezzafaceandbody/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-nerinas-bellezza-face-and-body-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-04T15:25:55",
    email: "sales@manlykayakcentre.com.au",
    name: "Manly Kayak Centre",
    address:
      "East Esplanade, East Pier, Manly Wharf, next to Manly Wharf Hotel, Manly, 2095",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "Established on Sydney Harbour in 1990, we are proud to be able to provide the most diverse range of aquatic products and services in Sydney. We are located in the picturesque Manly Cove where you can rent kayaks and stand-up paddleboards to paddle the pristine waters of North Harbour, exploring exclusive beaches and taking in stunning scenery!",
    currentSituationDescription:
      "We are open with a reduced range of products. Before we get you out on the water there are some extra measures that the crew will be taking to maintain the health and safety of our customers and staff. We have increased or added a number of precautions and ask that you, our awesome paddling community, do your part to help us out.\n- While Manly Kayak Centre has always maintained a hygienic environment, we will increase our cleaning to ensure that all surfaces, handles, terminals and frequently touched surfaces are disinfected throughout the day.\n- We will continue to rinse all equipment after use and will have disinfectant wipes on-site for anyone wanting to give their gear an extra swipe ahead of handling\n- We have a handwash station. Please make use of this before and after hire\n- We will have hand sanitiser along with our sunscreen to protect customers and staff\n- Mask and Snorkel Hire will no longer be available. All our sets have been thoroughly cleaned and disinfected and stored for the season\n- If you have pre-booked your experience you will receive a link to complete your waiver. Please do this ahead of time\n- We will no longer be keeping hold of any lost-property. All belongings left will be disposed of at the end of each day. If you think you have forgotten something please get in touch with us ASAP so we can organise for it to be kept to one side for you\n- If you have been unwell, have any flu-like symptoms, have travelled in the last two weeks or have been in contact with a person with, or under investigation for COVID-19; we ask that you do not come paddling. We appreciate your support always, but ask that you help us minimise the risk to our other paddlers and staff.",
    operatingHours:
      "Open 9:00 am – 5:00 pm seven days a week excluding some public holidays. \nWeather permitting. We do ask you to please phone ahead to confirm availability.",
    phoneNumber: "0412622662",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://manlykayakcentre.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/ManlyKayakCentre?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/manlykayakcentre/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/ManlyKayakCentre/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-kayak-centre-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-05T09:59:52",
    email: "art.smart@bigpond.com",
    name: "ArtSmart",
    address: "50 Ethel St, Seaforth NSW 2092, Australia",
    category: "Retail",
    businessDescription:
      "ArtSmart is the largest independently owned art supplies and picture framing store on Sydney’s Northern Beaches. We are a trusted Art hub providing advice and support to students and professionals. With a community focus we are actively involved with many of Sydney’s schools, art societies, museums, art competitions and galleries. We live and breathe art and feel fortunate to be the front and centre of Sydney’s creative community.\n\nOur art supplies store stocks a wide range of high-quality Australian made products, as well as a hand-selected range of overseas brands. We are also renowned for our quality custom frames and custom stretched canvases, loved by many for its quality workmanship, reliable delivery and great prices.\n\nArtSmart's retail space and framing workshop are easily accessible from the onsite customer parking area located up the car ramp next to the Thai restaurant on Ethel street. This access provides easy pickup/drop-off for customers and suppliers. Alternatively customers can access the shop via the street frontage at 50 Ethel street and walk up the stairs.\n\nFor art supplies, frames, canvas stretching, art classes, home art curation, artwork conservation and more, in Sydney’s Northern Beaches, look no further than ArtSmart. Contact us to make an appointment or pop in to speak to one of our friendly and helpful staff today.",
    currentSituationDescription:
      "ArtSmart is offering free delivery on art material to the local area. Customers can place orders on the artsmartartstore.com website, or alternatively phone or email us with an order. Our staff will pack the order and drop it at your door for no deliver charge. In addition there is a 10% discount when subscribing and placing the order via our website. \n\nArtSmart is also offering 20% off picture framing during the month of April. Simply bring your artwork into the store before the end of April to quality for this discount.",
    operatingHours:
      "Monday: 9am to 5pm\nTuesday: 9am to 5pm\nWednesday: 9am to 5pm\nThursday: 9am to 5pm\nFriday: 9am to 5pm\nSaturday: Closed\nSunday: Closed",
    phoneNumber: "0299497477",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://artsmartartstore.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ZEv2dSt7WJXp81AG9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-artsmart-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-05T11:32:12",
    email: "georginahartart@gmail.com",
    name: "Georgina Hart Art",
    address: "573 Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Advertising, Arts & Media",
    businessDescription:
      "At Georgina Hart Art you will find her Unique and whimsical paintings, prints, Adult Workshops, children's art classes and wonderful 'Takeaway Art' kits for the whole family. Commissions welcome.",
    currentSituationDescription:
      "We are now offering TAKEAWAY ART. These art kits include a video link on how to paint two different subjects, paint, pencils, brushes, paper, canvas and unique 'Paint with Georgina' canvases.  Creative Kids Vouchers are welcome to be used. Free Delivery in the area",
    operatingHours: "Monday - Friday 11am - 5pm",
    phoneNumber: "0416171863",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://georginahart.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Ae3Jj4CjRRjYavjf8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-georgina-hart-art-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-05T17:19:09",
    email: "wendy@colormaker.com.au",
    name: "Colormaker Industries",
    address: "44 Orchard Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription:
      "Colormaker Industries has over 60 years of manufacturing experience and is recognised as a premium sustainable producer of quality house paints, swimming pool coatings, waterproofing membranes, textile inks and industrial coatings.  The company is an Australian owned family business based on the Northern Beaches of Sydney with all products are made in Australia.\n\nAll products are manufactured at our Brookvale facility under strict quality control procedures using 100% renewable energy.\n\nMany of our products are available for purchase in Colormaker’s Online Shop.  These products include:\n\nCOLORMAKER interior & exterior house and wall paints\nCOLORMAKER paving paints\nRUSTEND rust prevention products\nACRYLMERIC contruction coatings including Concrete Sealers, Epoxacote floor coating & Texacote textured exterior coatings\nACRYLMERIC membranes including WeatherTuff exterior membrane, Sportscote trafficable membrane and Wet Area Membran\nLUXAPOOL swimming pool paints\nPERMASET screen printing inks\nPERMAPLASTIK scenic paints",
    currentSituationDescription:
      "We are still operational in a Brookvale making paint, selling paint to public and doing online orders for house paint, construction coatings, swimming pool paint & screen printing inks. Our hours are 7.30am to 4pm with customer parking at the rear of our building.",
    operatingHours:
      "Monday 7.30am-4pm\nTuesday 7.30am-4pm\nWednesday 7.30am-4pm\nThursday 7.30am-4pm\nFriday 7.30am-4pm",
    phoneNumber: "0299397977",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.colormaker.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/YzEx98UnCcuBEXAf9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-colormaker-industries-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T10:23:31",
    email: "alamaustralian@gmail.com",
    name: "North Steyne Snack Shack",
    address: "148 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "For more than 10 years, the North Steyne Snack Shack has remained one of the icons of the Manly community. A popular choice among Manly residents, the place is known for serving the tastiest Burgers, traditional Fish & Chips, healthy Juices and old school Shakes.",
    currentSituationDescription:
      "We are offering take away and delivery through UberEats, Deliveroo, Menulog and DoorDash",
    operatingHours: "Mon-Sun 10:30-10PM",
    phoneNumber: "0299777368",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.thesnackshack.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/JGXhdpAdzR6pYc2dA",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://instagram.com/ns_snackshack",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://facebook.com/NorthSteyneSnackShack/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-north-steyne-snack-shack-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T10:24:23",
    email: "info@cheeseonwheels.com.au",
    name: "Cheese on Wheels",
    address: "397 Sydney Rd, Balgowlah NSW 2093, Australia",
    category: "Food and Drink",
    businessDescription:
      "Cheese on Wheels was established in Sydney in 2012 by cheesemongers, Aurore Ghigo and Tom Ippolito. With a combined experience of nearly two decades, we aim to offer the best in artisanal, farmhouse cheeses and accompaniments from Australia and abroad.",
    currentSituationDescription:
      "We offer delivery of our cheeses & products as well as pickup/takeaway of our cheeses & products, cheese toasties and other menu items and takeaway coffee. We are not able to sell our cheeses at farmers markets as some markets have closed.",
    operatingHours:
      "Monday - Closed, Tuesday to Thursday - 9 AM to 5:30pm, Friday & Saturday - 9 AM to 6:30 pm and Sunday - Closed",
    phoneNumber: "0405924056",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://cheeseonwheels.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/LTL6vktQMWQ5PCwz6",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-cheese-on-wheels-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-cheese-on-wheels-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T11:14:20",
    email: "info@villagechiropracticmanly.com.au",
    name: "Village Chiropractic",
    address: "Level 1/3 Market Pl, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "We exist for our community. Village Chiropractic is a place where people come to get and stay well. Our main focus is on musculoskeletal issues but we approach it in a whole body way. We’ve been serving the Manly community for 15 years.",
    currentSituationDescription:
      "We are operating face to face for those that need the treatment. We also offer Telehealth options for any new patients or anyone at home due to the need to self isolate.",
    operatingHours: "Tuesday and Thursdays 8am-6pm and fridays 7am-11am",
    phoneNumber: "0299766311",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://villagechiropracticmanly.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Village+Chiropractic+Manly/@-33.7973347,151.2838183,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f4a7b9de1:0x68eeaaec4dfe3edf!8m2!3d-33.7973392!4d151.286007",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-village-chiropractic-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-village-chiropractic-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T11:37:11",
    email: "greatfood@platosrepublic.com.au",
    name: "Plato's BBQ Republic Seaforth",
    address: "1/533 Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Food and Drink",
    businessDescription:
      "Plato's is a  BBQ restaurant serving our Hibernation Take Home Dinner Menu plus  our popular .\n\nBBQ Family Dinner Packs \n8 Skewers \nof either Lamb or Chicken \nOr Half & Half served\nith Baked Vegetables Ratatouille, Lemon Potatoes ,Rice Pilaf , Tzatziki and grilled flat bread. \nServes 4-6 generously.",
    currentSituationDescription:
      "Plato's is operating a pickup take away menu , pre-orders are helpful but not essential. Our Hibernation Take Home Dinner Menu can be found on our website under the main menu as take away specials.",
    operatingHours:
      "Tuesday - Sunday 5pm till 7.30pm\\nOrders/inquries via our website, Facebook & phone",
    phoneNumber: "0280658226",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://platosrepublic.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/PLATO'S+REPUBLIC+MEDITERRANEAN+TAVERNA/@-33.7968742,151.2500305,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abc1ebdaa745:0x94ba110c99c39152!8m2!3d-33.7968742!4d151.2522245",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/platosrepublicseaforth/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-platos-bbq-republic-seaforth-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-platos-bbq-republic-seaforth-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-platos-bbq-republic-seaforth-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:12:13",
    email: "beth@theyogaspace.com.au",
    name: "The Yoga Space",
    address: "24 Carew St, Dee Why NSW 2099, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "The Yoga Space is a yoga sanctuary where you feel welcome, safe and uninhibited to just be and reconnect with yourself and connect with a like-minded community. The online classes are practices of Japanese Yoga, Yin Yoga and Meditation",
    currentSituationDescription:
      "The Yoga Space has moved online to a community group on Facebook. Classes are offered live in the group and can also be replayed anytime you like. There is a small monthly fee to join. For free taster classes and details on how to join checkout www.facebook.com/theyogaspaceTYS/",
    operatingHours: "Online on demand",
    phoneNumber: "0419413128",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.theyogaspace.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/The+Yoga+Space/@-33.7582111,151.2873306,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab019e04f329:0xbc9179c5b72d47b9!8m2!3d-33.7582111!4d151.2895246",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/theyogaspaceTYS/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-yoga-space-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-yoga-space-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-yoga-space-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:13:10",
    email: "deebeezumba@gmail.com",
    name: "Dee Bee Zumba classes",
    address: "1 Darley Rd Manly NSW 2095 Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Dee Bee Zumba classes now on-line! Feel energised every Wed & Sat 10am - all levels welcome, easy to follow routineas to awesome tunes! Dancing in your living room has never been so fun! $5/class.",
    currentSituationDescription:
      "Classes used to be every Saturday at the hall inside Manly Village Public School, which I hire. I used to get a lot of walk-ins and classes were fairly big, around 40 participants every week.  Now, classes are online for $5, every Wed & Sat 10am. All levels welcome.",
    operatingHours: "Wednesdays & Saturdays 10am",
    phoneNumber: "0422343599",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.zumba.com/en-US/profile/di-bugyi/429225",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/1+Darley+Rd,+Manly+NSW+2095/@-33.7984656,151.2841782,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f2c0481e1:0xa12d0808a455915d!8m2!3d-33.7984656!4d151.2863722",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/deebee.zumba",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-dee-bee-zumba-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:13:33",
    email: "bbsnorthsteyne@gmail.com",
    name: "BB,s Breakfast Bar & BBQ",
    address: "Shop 6/93-95 N Steyne, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Newly opened in  in December 2019 offering delicious breakfast deals with free coffee on the North Steyne Beach",
    currentSituationDescription:
      "Pick up coffee and limited menu from 7am to 2pm",
    operatingHours:
      "monday 7-2 Tuesday 7-2 Wednesday 7-2 Thursday 7-2 Friday 7-2 Saturday 7-2 Sunday 7-2",
    phoneNumber: "0299762284",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://bbsnorthsteyne.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/BB's+Breakfast+Bar+%26+BBQ/@-33.7912698,151.2846106,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abc64cfd83e3:0x33c65d49462d6503!8m2!3d-33.7912698!4d151.2868046",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/bbs.breakfast.bar/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bbs-breakfast-bar-bbq-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:13:58",
    email: "manly@mongers.com.au",
    name: "Fishmongers",
    address:
      "Shop 4, 11-27 Wentworth Street Rialto Square, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Gourmet Fish and Chips, renowned for local sustainable seafood and hand cut chips with an Asian twist!",
    currentSituationDescription:
      "Full menu available for takeaway and delivery",
    operatingHours: "Midday - 9pm 7 days",
    phoneNumber: "0299771777",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.mongers.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.co.nz/maps/place/Fishmongers+Manly/@-33.7912648,151.2516888,13z/data=!4m8!1m2!2m1!1sFishmongers!3m4!1s0x6b12ab0f18c38015:0xacdd83580bd0f42f!8m2!3d-33.7985194!4d151.287475",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fishmongers-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fishmongers-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fishmongers-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:23:52",
    email: "info@balgowlahseafood.com.au",
    name: "Fishcafe Balgowlah",
    address: "Shop 70 215 Condamine St, Balgowlah NSW 2093, Australia",
    category: "Food and Drink",
    businessDescription: "Seafood restaurant/fish n chips",
    currentSituationDescription: "Take away/Uber eats for delivery",
    operatingHours: "Thursday-Sunday 5-9",
    phoneNumber: "0299494945",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://fishcafebalgowlah.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Fish+Cafe+Balgowlah/@-33.7933005,151.2622093,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abbbad89a999:0x47167af8a4bb4730!8m2!3d-33.793305!4d151.264398",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fishcafe-balgowlah-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fishcafe-balgowlah-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-fishcafe-balgowlah-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:27:24",
    email: "viniandbros@gmail.com",
    name: "Vini’s Cafe",
    address: "Shop 1a/13 Victoria Parade, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: null,
    currentSituationDescription:
      "All day breakfast and lunch available for pick up until 3pm. Orders for dinner will be taken until 3pm. Pick up or delivery available between 5-6pm.",
    operatingHours:
      "6:30am - 4pm breakfast and lunch\nDinner available for pick up or delivery between 5-6pm. Orders must be placed until 3pm on 0424 908 037 or Hey You app",
    phoneNumber: "0424908037",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Vini's+Cafe/@-33.7999825,151.2849073,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab086e6b878b:0xb1532df0c08e62fb!8m2!3d-33.799987!4d151.287096",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/vinismanly/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-vinis-cafe-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-vinis-cafe-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:27:26",
    email: "carly@ozsquad.com.au",
    name: "OzSquad",
    address: "104 N Steyne, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "At OzSquad we don’t believe in before and after photos, crash diets or weight loss challenges. We believe in exercising to feel good, more energised and ready for the day ahead - even more important in these crazy times. We believe in shaking up stale exercise routines, increasing daily activity, exercising for physical and mental health and wellbeing and always encourage a bit of friendly banter too.",
    currentSituationDescription:
      "For all our virtual members, we now offer 12 LIVE Zoom classes per week, recorded classes on demand, solo outdoor work-out plans, access to a private members group for mini-challenges and accountability plus virtual socials (our Friday evening 'Gym & Tonic' session is a HIT!). We are also available for outdoor one-on-one PT sessions at our usual North Steyne spot.",
    operatingHours:
      "LIVE sessions Monday 9am, 7pm, Tuesday 7am, 11.45am, 7pm, Wednesday 7am, 9am, 7pm, Thursday 7am, 11.45am, Friday 9am, 5pm",
    phoneNumber: "0408700765",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://ozsquad.com.au/virtual-bootcamp/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ADc6h6fDbctqsHPE9",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/OzSquad/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-ozsquad-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-ozsquad-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:29:41",
    email: "enquiries@manlyrentals.com.au",
    name: "Manly Rentals",
    address: "65 Kenneth Rd, Manly Vale NSW 2093, Australia",
    category: "Trades and Services",
    businessDescription: "Providing reliable vehicles on a budget since 1952.",
    currentSituationDescription:
      "Vehicles are being sanitised and all operations have been optimised for good hygene.",
    operatingHours: "Monday - Saturday: 8am until 5pm, Sunday: 8-10am + 4-5pm",
    phoneNumber: "0299493554",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlyrentals.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Car+%26+Truck+Rentals/@-33.7869606,151.2666339,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abb1fce81e85:0x122cee6103a679a7!8m2!3d-33.7869651!4d151.2688226",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-rentals-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T12:51:32",
    email: "info@divesydney.com.au",
    name: "Dive Centre Manly",
    address: "10 Belgrave St, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Dive Centre is a family run business situated closest to Sydney's best dive sites. Being a multi-award winning PADI 5 Star Instructor training facility, we offer a complete range of dive courses from Discover Scuba to Instructor level and beyond. Come learn to dive with us on our private courses during this period or grab your snorkel/dive gear from our store open on weekends.",
    currentSituationDescription:
      "We are now operating during weekdays out of our Dive Training Centre - Unit D1 / 1 Campbell Parade, Manly Vale and out of our Dive Store during the week - 10 Belgrave Street, Manly",
    operatingHours:
      "Mon-Fri 9am-5pm Dive Training Centre \nSat-Sun 9am-5pm Dive Shop",
    phoneNumber: "0299774355",
    pickup: true,
    delivery: true,
    websites: [],
    images: null,
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T13:05:20",
    email: "info@paceathletic.com",
    name: "Pace Athletic",
    address: "23 Sydney Rd, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "To Inspire health and fitness adventures through a specialised experience and premium product. We are your local running store. Our staff live and breathe what we preach and love helping our customers achieve their fitness goals by ensuring they have the correct gear for their needs.",
    currentSituationDescription:
      "At this stage our doors are still open and we're happy to fit customers for their new running shoes. We've added extra precautions to maintain social distancing guidelines and make sure are store is clean and germ free.",
    operatingHours: "https://paceathletic.com/pages/store-locations",
    phoneNumber: "0289648871",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://paceathletic.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Pace+Athletic/@-33.7972875,151.2841445,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f4bececc1:0x56717d4e81d7175d!8m2!3d-33.797292!4d151.2863332",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-pace-athletic-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T13:39:45",
    email: "murray@hamerlaw.com.au",
    name: "Hamer & Hamer Balgowlah",
    address: "Suite 4, 383 Sydney Rd, Balgowlah NSW 2093, Australia",
    category: "Trades and Services",
    businessDescription:
      "Hamer & Hamer Solicitors has been operating in Balgowlah for 46 years. We assist our clients in a wide range of matters with our main areas of practice being conveyancing and property advice, wills and estate planning, deceased estates, family law, small business and general advice. Our team all lives on the northern beaches and we have a wealth of local knowledge in our business.",
    currentSituationDescription:
      "We are continuing to assist clients with their legal issues however are going about it in a different way with teleconferencing and videoconferencing to meet with clients to discuss their matters and electronic signing of documents. When documents must be signed in person in front of a lawyer we have procedures in place to ensure that social distancing guidelines are followed for the protection of our team and our clients.",
    operatingHours:
      "Monday 8:30am-5pm\nTuesday 8:30am-5pm\nWednesday 8:30am-5pm\nThursday 8:30am-5pm\nFriday 8:30am-5pm",
    phoneNumber: "0299494022",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.hamerlawyers.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Hamer+%26+Hamer/@-33.7946044,151.2619312,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abbb955c9e61:0xa08c9de9d6359695!8m2!3d-33.7946089!4d151.2641199",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-hamer-hamer-balgowlah-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T13:49:15",
    email: "arora@sketchbar.com.au",
    name: "Sketch Manly",
    address: "19 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "We're a hole in the wall family run cafe-bar-curry place. Doing the best coffee (as per few many locals & Google ratings), fresh breakfast & decadent Indian curries along with best selection of packaged craft beer on the beaches.",
    currentSituationDescription:
      "We've set up Sketchmanly.com\nOnline ordering for pick up and delivery. Helps you skip the que - and maintain social distancing, whilst being able to get your daily coffee, brekky, craft beer & curry fix.",
    operatingHours:
      "We're trading everyday 7AM-1PM & Thursday thru to Sunday evenings from 5.30PM-8.30PM",
    phoneNumber: "0468747792",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.sketchmanly.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Sketch/@-33.7948167,151.2827117,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab06140e5297:0xb8594b4a073ead37!8m2!3d-33.7948212!4d151.2849004",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/sketchmanly/",
        text: null,
      },
      {
        type: "Facebook",
        url: "http://www.facebook.com/sketchmanly",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-sketch-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-sketch-manly-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T13:56:33",
    email: "hello@mandalaliving.com.au",
    name: "Mandala Living (Eco friendly Yoga and Meditation Essentials)",
    address: "8 Clearview Pl Brookvale NSW 2100 Australia",
    category: "Retail",
    businessDescription:
      "We make locally yoga, meditation and relaxation cushions and bolsters to help you create a sanctuary in your home. All our cushions are made with eco friendly, recycled materials.",
    currentSituationDescription:
      "We are still making a small range of eco friendly yoga and meditation accessories for people to practice in their own home. People can collect from our warehouse in Brookvale or we can deliver.",
    operatingHours:
      "People can buy through our website and we are open by appointment. Items can be collected from warehouse in Brookvale btn 8am - 5pm Monday - Saturday and 10am -4pm on Sundays. Not open public holidays.",
    phoneNumber: "0458324018",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.mandalaliving.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/8+Clearview+Pl,+Brookvale+NSW+2100/@-33.7618865,151.2594715,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa41761ae8f1:0x5482b710ad8f9546!8m2!3d-33.761891!4d151.2616602",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/mandalaliving/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/mandalaliving/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-mandala-living-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:00:32",
    email: "amerigo@harbordgrowers.com.au",
    name: "Harbord Growers Market",
    address:
      "Stockland Balgowlah, 197-215 Condamine St, Balgowlah NSW 2093, Australia",
    category: "Food and Drink",
    businessDescription:
      "Harbord Growers Market is a family-owned greengrocer, operating for over 26 years and over three generations. Located at Stockland Balgowlah, Harbord Growers Market provides customers with the freshest produce, quality groceries, salads, juices, and take-home meals. We have extended our friendly service to Online Shopping and Click & Collect. Order from your smartphone, tablet or laptop from your kitchen bench and we'll deliver straight to your front door.",
    currentSituationDescription:
      "Our Balgowlah Fruit and Vegetable Market is open for in-store shopping, Click & Collect and Home Delivery",
    operatingHours:
      "Store is open: Monday to Friday 7am to 7pm; Sat & Sun: 7am to 6pm. \nOnline Shopping: 24/7 \nClick & Collect: Mon to Fri: 10am to 6.30pm; Sat to Sun: 10am to 5.30pm. \nLocal Home Delivery: Mon to Sun between 12pm to 7pm\nUpper Northern Beaches: Mon to Fri between 2pm and 5pm\nLower North Shore Dleivery: Weekdays between 2pm and 5pm",
    phoneNumber: "0299494355",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/trXSy7i6uy1FboM18",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/harbordgrowers",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/HarbordGrowersMarket",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-harbord-growers-market-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:06:24",
    email: "info@barenakedbowls.com.au",
    name: "Bare Naked Bowls Manly",
    address: "Shop 2/41 Market Pl, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Bare Naked Bowls is a superfood cafe specialising in Acai Bowls, Nourish Bowls, Yoghurt Bowls and Superfood smoothies.",
    currentSituationDescription:
      "Same delicious menu as before just pick up and delivery - we’ve never been on deliveroo before but you can find us there now.",
    operatingHours: "8-3",
    phoneNumber: "0477014068",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.barenakedbowls.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Tr2sGUoAmYkKu9FR7",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/barenakedbowls/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bare-naked-bowls-manly-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:10:55",
    email: "custom.cafe.brookvale@gmail.com",
    name: "Custom cafe",
    address: "17 Sydenham Rd, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "Great coffee shop, located in the heart of Brookvale, beautifully decorated, great coffee, serving the healthiest food in Brookvale always with a smile.",
    currentSituationDescription:
      "Doing take away and delivery.\nThe whole menu is available including coffee food and cold drinks.\nClose on Saturday and Sunday from this week until further notice.",
    operatingHours:
      "Monday 6am till 4pm\nTuesday  6am till 4pm\nWednesday  6am till 4pm\nThursday  6am till 4pm\nFriday  6am till 4pm",
    phoneNumber: "0435329505",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://g.page/customcafebrookvale?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/custom.cafe.brookvale/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/custom.cafe.brookvale/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-custom-cafe-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:19:19",
    email: "nspencer@mtatravel.com.au",
    name: "MTA TRAVEL - NATASHA SPENCER",
    address: "Mobile Travel agent - based in Narraweena",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "Local travel agent that cares and with you all the way!",
    currentSituationDescription:
      "All travel has suspended for immediate future all immediate future bookings have stopped with travel bans in place and airlines/cruise ships coming to a halt. Would be great to be supported by local community in arranging their future travel for 2021 and using local travel agent and supporting locally rather than overseas online travel provider",
    operatingHours: "Available 7 days by appointment",
    phoneNumber: "0419275899",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://agents.mtatravel.com.au/nspencer",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/mtatravel_natashaspencer/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/NatashaSpencerMTA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-mta-travel-natasha-spencer-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:43:23",
    email: "missbeatrice2093@gmail.com",
    name: "Miss Beatrice",
    address: "124 Beatrice St, Balgowlah Heights NSW 2093, Australia",
    category: "Design and Architecture",
    businessDescription:
      "Miss Beatrice is located in the village of Balgowlah Heights;  we supply beautiful flowers brought from our markets 3 times a week, predominantly and proudly from our own Australian growers. We also carry a unique range of complimentary homewares and an extensive range of locally sourced houseplants to make your house a home. All our staff are local and we LOVE our community.",
    currentSituationDescription:
      "We are providing free local deliveries of either flowers and or homewares to our customers",
    operatingHours:
      "Monday 8-5.30, Tuesday 8-5.30, Wednesday 8-5.30, Thursday 8-5.30, Friday 8-5.30, Friday 8-5.30, Saturday 8-5.30 and Sunday 8-2pm",
    phoneNumber: "0299484980",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.missbeatrice.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/missbeatrice2093?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/missbeatrice2093/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-miss-beatrice-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-miss-beatrice-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T14:56:51",
    email: "info@beachesbaby.com.au",
    name: "Beaches Baby",
    address:
      "Diggers - Opposite Carpark Entrance, 88 Evans St, Freshwater NSW 2096, Australia",
    category: "Retail",
    businessDescription:
      "Created to support new parents from bump to baby and beyond. We are your parenting village.",
    currentSituationDescription:
      "We are open for shopping and online order pickup Monday Wednesday and Friday and we are doing free delivery in a 5km radius or $10 shipping. We also have online prenatal education and support groups.",
    operatingHours: "9am - 12pm Monday, Wednesday and Friday",
    phoneNumber: "0299051717",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.beachesbaby.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/isEVgnQj1DJFVW7M9",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/beachesbabyfreshwater/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/beachesbabyfreshwater/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-beaches-baby-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-beaches-baby-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T15:32:47",
    email: "info@theherringroom.com.au",
    name: "The Herring Room",
    address: "94 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Manly locals favourite gem, family owned and operated. We are all about soulful restaurant quality meals you can have at home. From our family to yours.",
    currentSituationDescription:
      "We are now offering takeaway - pick up organised by calling us or delivery through the Deliveroo and Ubereats apps. Our menu is available on our website. You’ll get 10% off if you pick up - plus you’ll be supporting your local business more!",
    operatingHours:
      "Monday 4-9\nTuesday 4-9\nWednesday 4-9\nThursday 4-9\nFriday 4-9\nSaturday 4-9\nSunday 4-9",
    phoneNumber: "0299772572",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://theherringroom.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/The+Herring+Room/@-33.7927778,151.2858333,15z/data=!4m2!3m1!1s0x0:0x8bc741660e82d876?sa=X&ved=2ahUKEwiUor7Ci9joAhXEjOYKHdpHCpwQ_BIwDXoECB4QCA",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/theherringroom",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-herring-room-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-herring-room-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-herring-room-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T15:38:18",
    email: "lusciouskikicakes@gmail.com",
    name: "LusciousKiki Cakes",
    address: "16 Sydenham Rd, Brookvale NSW 2100, Australia",
    category: "Food and Drink",
    businessDescription:
      "Luscious creates hand made, quality lamingtons, cakes, slices, brownies & biscuits with an emphasis on fresh, seasonal Australian produce & incorporates Indigenous produce whenever possible.",
    currentSituationDescription:
      "Luscious has always offered dine in & take-home yum-yums, however due to the current situation, now offering take-home only. We have also created Petite Wedding Cakes in line with the current restrictions for wedding parties.",
    operatingHours:
      "Fridays & Saturdays 8am to 3pm, or other days via pre-order.",
    phoneNumber: "0417499022",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.lusciouskikicakes.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/LusciousKiki+Cakes/@-33.7645998,151.2713528,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa5dce82016d:0x679c99b2bb58f44b!8m2!3d-33.7646043!4d151.2735415",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-lusciouskiki-cakes-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-lusciouskiki-cakes-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T15:49:37",
    email: "luke@lucespace.com",
    name: "Tribe Manly",
    address: "3b/11 Wentworth St, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "A friendly local salon where great service and quality product is paramount. All of our hair products are essentially damage free, to both our clients and the environment. Our team are some of the best in the industry and current finalists in the 2020 Australian hairdressing awards.",
    currentSituationDescription:
      "We are operating restricted hours with a skeleton team",
    operatingHours: "Now open Wednesday 9am - 6pm and Saturday 9am - 530pm",
    phoneNumber: "0290569210",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.tribelifestyle.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Tribe+Lifestyle+Hairdresser+Manly/@-33.7969545,151.2841863,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f222c4955:0xacdf81d11ae67a66!8m2!3d-33.796959!4d151.286375",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-tribe-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-tribe-manly-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T16:03:46",
    email: "brooke@zeusproductions.com.au",
    name: "Zeus Productions",
    address: "6/240 Harbord Rd, Brookvale NSW 2100, Australia",
    category: "Advertising, Arts & Media",
    businessDescription:
      "We are a Brookvale based creative team specialising in Branding & Photography. We’ve refreshed, revived & reinvigorated countless local businesses over the years. Bringing ideas to life & elevating brands to their full potential.",
    currentSituationDescription: "No contact meetings and Photoshoot.",
    operatingHours: "Open 9am -5pm Mon -Friday",
    phoneNumber: "0450437978",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.zeusproductions.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Zeus+Productions/@-33.7597034,151.2781538,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa867a7b8aeb:0xf6f8c26a58183a69!8m2!3d-33.7597079!4d151.2803425",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-zeus-productions-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-zeus-productions-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-zeus-productions-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T17:05:11",
    email: "too_pawana@hotmail.com",
    name: "Yok Thai Restaurant Manly",
    address: "Shop B 11-20 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Yok is Thai Inspired cuisine and wine restaurant. The house-recipes are designed to showcase a lovely combination of our Thai cooking approach and Australian produce. While focusing the work on offering a unique menu through our endless culinary passion, we are committed to providing a selection of delicious wines & beverages to have all the dishes beautifully complemented.",
    currentSituationDescription:
      "The same dining-in menu is offered for pickup & delivery orders. Our beloved customers can enjoy their favourites; Salmon Ceviche, Zucchini Flowers, Panang Roast Duck Curry, Ginger John Dory, BBQ Lamb Cutlets, Thai Basil Prawns, Aus Eye Fillet Thai Salad and a lot more at  their very own home",
    operatingHours: "Monday - Sunday: 12:00 pm - 9:00 pm",
    phoneNumber: "0299766488",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.yokthaitapas.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Yok+Thai+Restaurant/@-33.7986412,151.2852655,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f105ac119:0x9632ad41b558a69f!8m2!3d-33.7986457!4d151.2874542",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/yok_thai_tapas_wine/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/yokthaitapas",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-yok-thai-restaurant-manly-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-yok-thai-restaurant-manly-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T17:43:11",
    email: "ddellala@momobar.com.au",
    name: "Momo Bar Manly and Dee Why",
    address: "28 Market Pl, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription: "https://www.facebook.com/manlymomobar",
    currentSituationDescription:
      "Momo Bar was open within 12 hours of the Government restrictions laid down on Sunday 22nd March. \n\nWe are taking every step to ensure Momo Bar locations follow all health, safety and Hygiene requirements and recommendations during this unprecedented time of uncertainty.\n\nWe encourage contactless payments, will be distributing disposable cutlery only and have briefed our staff to continue to practice vigilant levels of hygiene \n.\nIf you have been overseas recently, are feeling unwell, have a fever, cough or flu-like symptoms, we encourage you to stay at home, rest and seek medical advice. We are monitoring the situation closely and doing everything we can to stay up to date, but otherwise its business as usual.\n\nWe would like to thank you for your continued patronage and support of small businesses during this time.\n\nWe are Being digitally enabled (contactless) and a data lead restaurant we are  positioned well to serve our customers by the following channels \n\n1. Take Away\n2. Gift Cards - http://bit.ly/momobargiftcard\n2. Order Ahead (Takeaway). Hey You Beat the Q (more to come)\n3. Delivery via UberEats,  Deliveroo and (more to come)",
    operatingHours: "11am to 9pm",
    phoneNumber: null,
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://bit.ly/momobarmanlyheyyou",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Momo+Bar.+Dumplings+%26+Pokè/@-33.7986412,151.2852655,17z/data=!4m5!3m4!1s0x6b12ab0f16a4090b:0xacd7aabdc67048e5!8m2!3d-33.797573!4d151.286404",
        text: null,
      },
      {
        type: "CallToAction",
        url: "https://bit.ly/momobarmanlyheyyou",
        text: "Hey You",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-momo-bar-manly-and-dee-why-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T19:22:08",
    email: "hbmobilecoffee@gmail.com",
    name: "HB Mobile Coffee",
    address: null,
    category: "Food and Drink",
    businessDescription:
      "At HB Mobile Coffee I believe when it comes to coffee it’s black and white.\nI look forward to serving you quality coffee on the Lower Northern Beaches.",
    currentSituationDescription:
      "This Mobile Coffee van can come visit you at your businesses, schools, or local neighbourhood to provide you with delicious coffee.",
    operatingHours:
      "By request. \n$50 minimum spend per booking, so get your co-workers or neighbours together for a physically distant but socially connected coffee.",
    phoneNumber: null,
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Instagram",
        url: "https://www.instagram.com/hbmobilecoffee",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/hbmobilecoffee",
        text: null,
      },
      {
        type: "CallToAction",
        url: "https://www.facebook.com/hbmobilecoffee",
        text: "Message us on Facebook",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-hb-mobile-coffee-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-hb-mobile-coffee-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T20:45:24",
    email: "turningpointeps@gmail.com",
    name: "Turning Pointe Pilates",
    address: "4121/834 Pittwater Rd, Dee Why NSW 2099, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "We're passionate about helping people feel better in their bodies.  Our highly trained instructors have experience working for physio clinics helping clients take their rehab to the next step.   We are also experienced in working with seniors,  and elite athletes.",
    currentSituationDescription:
      "All our classes are now online so people can continue to exercise in the comfort and safety of their own home.   We offer private sessions, semi-privates with a max of 3, and small group fitness with a max of 8. Class numbers are strictly limited to ensure clients get personalised workouts to suite their needs.  We can see and hear you, you can see and hear us and we can guide and correct alignment through Zoom.",
    operatingHours:
      "Classes run Monday to Saturday through our online booking www.supersaas.com/schedule/djazzex/pilates",
    phoneNumber: "0435293748",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.turningpointepilates.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Turning+Pointe+Pilates/@-33.7551779,151.284276,15z/data=!4m2!3m1!1s0x0:0xa3f0182688c69b1d?sa=X&ved=2ahUKEwjmp5bh4tjoAhX38XMBHYtMA2sQ_BIwDXoECBsQCA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-turning-pointe-pilates-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-turning-pointe-pilates-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-turning-pointe-pilates-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-06T23:29:46",
    email: "francisco@manlybiketours.com.au",
    name: "Manly Bike Tours",
    address: "Shop 7/54 West Esplanade, Manly NSW 2095, Australia",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "E Bikes on a Weekly Basis - Bike Repairs and Services - Second Hand Bikes for Sale",
    currentSituationDescription:
      "Manly Bike Tours worked with tourism. 97% of the profits came from Bike Hire for tourist to discover Manly. So we are trying to shift the business model to survive, until hopefully everything goes back to normal.",
    operatingHours: "With Appointment +61 410 234 231",
    phoneNumber: "0410234231",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlybiketours.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Bike+Tours/@-33.7987086,151.2822284,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0919010f83:0x891b9d0467ed9357!8m2!3d-33.7987086!4d151.2844117",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bike-tours-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T06:36:49",
    email: "davida@38xfitness.com.au",
    name: "38X Fitness",
    address: "1/167 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Our vision is to improve the health and vitality of the northern beaches community.",
    currentSituationDescription:
      "With the forced closure of fitness studios we are offering virtual fitness coaching as well as 1:1 outdoor training. There are both free and low cost options for you to check out.",
    operatingHours:
      "Virtual options to follow at a time that suits. Private training by appointment.",
    phoneNumber: "0404481303",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://38xfitness.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/38X+Fitness/@-33.7893977,151.282435,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab01407a845d:0xe88c81364cfea283!8m2!3d-33.7893977!4d151.2846183",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-38x-fitness-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-38x-fitness-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T07:53:59",
    email: "amhamadache@optusnet.com.au",
    name: "A&M HAMADACHE CAR DETAILING",
    address: "17 Sydenham Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription:
      "A & M Hamadache Vehicle Detailing was established in 1995 and prides itself on providing the highest quality detailing service on the Northern Beaches. With a large base of satisfied returning customers, many of whom have been with us since we started in 1994, A & M Hamadache offers the unique combination of experience, quality and value.",
    currentSituationDescription: "We still open",
    operatingHours: "Monday to Saturday from 7.30 am to 5.30 pm",
    phoneNumber: "0299050690",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.amhamadache.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/gU5pMoitENaf4FDk7",
        text: null,
      },
      {
        type: "Facebook",
        url: "http://www.facebook.com/AmHamadachePtyLtd",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-a-m-hamadache-vehicle-detailing-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T07:54:20",
    email: "jeff@manlycovepodiatry.com",
    name: "Manly Cove Podiatry",
    address: "Suite 12/35-36 E Esplanade, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription: "Providing Podiatry services in Manly since 1994",
    currentSituationDescription:
      "We are taking every possible hygiene measure to prevent the spread of Covid19 with hand washing and hand sanitiser for all staff and patients, hospital grade disinfectant, appointments are being spaced to minimise any waiting or contact with others",
    operatingHours:
      "Monday 8am-6pm, Tuesday 8am-6pm, Wednesday 8am-12pm, Thursday 8am-6pm, Friday 8am-6pm",
    phoneNumber: "0289669552",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlycovepodiatry.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/VJ23QSLf711i13sB8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-cove-podiatry-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T07:56:55",
    email: "sales@manlycycles.com.au",
    name: "MANLY CYCLES",
    address: "36 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription: "Manly's longest running bike shop",
    currentSituationDescription:
      "Please call ahead to book for servicing - Order by phone or email",
    operatingHours:
      "Monday 12-6\nTuesday 9-6\nWednesday 9-6\nThursday 10-7\nFriday 9-6\nSaturday 9-5\nSunday Closed",
    phoneNumber: "0299771189",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://manlycycles.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Ev2vaeDjxFs6vByu9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-cycles-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T08:36:37",
    email: "fusionpoint@bigpond.com",
    name: "Fusion point",
    address: "12/1-21 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Servicing manly local for exceptional coffee \nComprehensive menu that caters for different dietary requirements \nFor the last 20 years \nWe’re our locals love  to come \nFrom breakfast to lunch and dinner",
    currentSituationDescription:
      "Take away food and coffee and both pick up and delivery",
    operatingHours:
      "6am to 8pm \nMonday Tuesday Wednesday Thursday Friday Saturday Sunday\\nYou may also contact us via 02 8966 9999",
    phoneNumber: "0405313969",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.fusionpoint.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ddZygk2t1XzRBwYz8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fusion-point-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T08:45:47",
    email: "info@toneathletica.com",
    name: "Tone Athletica",
    address: "3b1, 106 Old Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Tone Athletica exists to empower women to be self confident and love their body through our training methods and community \n\nOur Tone Tribe is a group of like minded women who strive to be their best each day with the help of our experienced coaches",
    currentSituationDescription:
      "Our female functional gym has moved to an online virtual gym & social club!",
    operatingHours:
      "Monday - Friday 7am, 9:30am & 5pm live zoom classes + replays in the comfort of you’re own home! \n\nOur social club provides coffee catch ups, wine time and cooking club",
    phoneNumber: "0449132466",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.toneathletica.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ETFKBvgdYxAvFiDZA",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-tone-athletica-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:25:38",
    email: "brigitte@manlyjewellers.com",
    name: "Manly Jewellers",
    address: "14/17-25 Wentworth St, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "Manly Jewellers specialise in manufacturing and designing one of a kind custom made jewellery pieces just for you. They also pride themselves on their beautiful craftmanship when it comes to repairing & remodelling your jewellery. With over 20 years jewellery experience on Sydney's Northern beaches, they welcome your enquiry.",
    currentSituationDescription:
      "Manly Jewellers are open by appointment. Just email brigitte@manlyjewellers.com and she can still assist with all your jewellery requirements.",
    operatingHours: "By Appointment: brigitte@manlyjewellers.com",
    phoneNumber: null,
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlyjewellers.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Jewellers/@-33.7983144,151.2857875,17z/data=!3m1!4b1!4m5!3m4!1s0x6b0d549816d03ac7:0xd85c507c3e6cb10c!8m2!3d-33.7983144!4d151.2879708",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-jewellers-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-jewellers-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-jewellers-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:34:31",
    email: "chris@expressmortgagesolutions.com.au",
    name: "Express Mortgage Solutions",
    address: "Lister Ave, Seaforth, NSW 2092, Australia",
    category: "Trades and Services",
    businessDescription:
      "Mortgage & Finance Solutions, because I love to help people find solutions based on their needs.",
    currentSituationDescription:
      "Hi, i'm finding at the moment that businesses, Sole Traders (mostly) Mum & Dad PAYG's are overwhelmed with information, not fully aware of what their options are as a family AND individually. At this point in time, its great to reassess your business and personal position. I/we can offer specific advise related to their particular needs, because everyone is different.",
    operatingHours: "24/7  - work from home",
    phoneNumber: "0434218737",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.expressmortgagesolutions.com.au/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-express-mortgage-solutions-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:36:57",
    email: "david@mmjarchitects.com.au",
    name: "mm+j architects",
    address: "Unit 1/36-42 Sydney Rd, Manly NSW 2095, Australia",
    category: "Design and Architecture",
    businessDescription:
      "architects for residential alterations, additions and new works",
    currentSituationDescription: "avialable as required to meet via zoom",
    operatingHours: "Monday to Friday 8:30am to 5:30pm",
    phoneNumber: "0425245223",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.mmjarchitects.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/mm%2Bj+architects/@-33.7969027,151.2841362,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aba7ceb8fe89:0x833a6682611961ae!8m2!3d-33.7969072!4d151.2863249",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/mmjarchitects",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-mmj-architects-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-mmj-architects-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-mmj-architects-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:41:22",
    email: "eliza@divineflowyoga.com",
    name: "Divine Flow Yoga",
    address: "22 William St, Brookvale NSW 2100, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "The Divine Flow adventure  begins in 2015, when Eliza left her corporate job behind. It was from here that Divine Flow’s mantra became truly rooted to what it is today. A place of healing and growth for all bodies. From 2016, Eliza opened her first beautiful boutique studio in Brookvale on Wattle rd- a place of solitude and growth for the Divine Flow community.\n\nFast forward to today where owners, husband and wife, Eliza and Andrew work together hand in hand through their shared passion of yoga, meditation, beach lifestyle and community. They worked hard together to build the studio you see today in William st. They continue to evolve and explore the many ways they can bring the Divine Flow community through the beautiful practice of yoga,",
    currentSituationDescription:
      "We are now online. We offer yoga and pilates LIVE from our studio and also have an on demand option so you can practice your favourites anytime! Our premium online service is directly accessed from our website making yoga, meditation and pilates accessible and approachable.",
    operatingHours: "We have a new LIVE timetable displayed on our website.",
    phoneNumber: "0413713380",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://divineflowyoga.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Divine+Flow+Yoga/@-33.7681849,151.2683635,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa5f331ef8c7:0xe799fd2bd6d6aefc!8m2!3d-33.7681894!4d151.2705522",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/divineflow_yoga/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/divineflowyogastudio",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-divine-flow-yoga-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-divine-flow-yoga-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:43:53",
    email: "enquiry@smsfconsulting.com.au",
    name: "Easy Super",
    address: "19 Selby Ave, Dee Why NSW 2099, Australia",
    category: "Trades and Services",
    businessDescription:
      "Accounting, audit and advice Services for Self Managed Super Funds (SMSF) trustees. Providing an advice on self managed super funds and COVID-19 relief and measures available for SMSF Trustees. Also, I have a special offer during COVI-19 to support a community. We are giving 50% discount on the annual services for SMSF (financials and tax return preparation and lodgment)",
    currentSituationDescription:
      "Working from home, providing online and over the phone advice",
    operatingHours: "from 8 am till 7 pm, 7 days a week",
    phoneNumber: "0432366690",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.smsfconsulting.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/yk4wMM4T7nbw1kHz7",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/easysuperau/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-easy-super-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:50:22",
    email: "Louise@nourishingnosh.com.au",
    name: "Nourishing Nosh",
    address: "16 Benelong St, Seaforth NSW 2092, Australia",
    category: "Food and Drink",
    businessDescription:
      "Nourishing Nosh nurtures the skills to create and encourages the consumption of delicious, nutritious, wholesome food that brings joy to those who make it, share it and eat it.",
    currentSituationDescription:
      "I run a mixed nutrition education, catering and cooking class business. Since 2012 I've been catering and running cooking classes, cooking demonstrations and nutrition seminars for individuals, schools and workplaces. I am now presenting virtually and offer small group cooking classes and individual nutrition consultations. I'm also running webinars, complete with cooking demonstrations for corporates and schools.",
    operatingHours:
      "Hours are flexible and can include evening classes: Monday to Friday 8am - 9pm (if classes running) Saturday 9am - 1pm",
    phoneNumber: "0401370379",
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.nourishingnosh.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/7ckTWY7YVechjxoz9",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/NourishingNosh/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-nourishing-nosh-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T09:52:15",
    email: "steve@activenetworks.com.au",
    name: "Peninsula Living",
    address: "225/117 Old Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription:
      "Keen to promote your sale, service or product or just want to let locals know your still trading. We can help. Reach tens of thousands of locals through our Think Local website, our email newsletters  and our Buy Sell Swap and Connect Facebook groups.",
    currentSituationDescription:
      "We have temporarily stopped our print editions but are still offering business the ability to advertise on our digital media",
    operatingHours:
      "We are on skeleton staff Monday to Friday. Best means of contact is email or phone",
    phoneNumber: "0403398744",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.activenetworks.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/JsBraCHNN5cAKA5X9",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/ActiveNetworksPTY/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-peninsula-living-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T10:01:45",
    email: "joe@energyculture.com.au",
    name: "Energy Culture",
    address: "North Balgowlah, New South Wales 2093",
    category: "Trades and Services",
    businessDescription:
      "Energy Culture is here to help our customers have great solar and electrical In a more sustainable  way. We choose our products based on the quality  and what the company behind the product is doing either environmentally or socially or both.\nWe’ve been awarded by the northern beaches council, finalist in a Nsw Green Globe award.",
    currentSituationDescription:
      "Well our solar meetings have been moved online as are now done with a zoom call, this keeps the face to face interaction down to a minimum.\nOur customers have a better experience and have a better visual of the products and any other questions they have can be answered easily with our video presentation. It’s easy for you jump online, book a time and our solar guy Forrest Campbell will answer all you solar questions.\nPlease use this link https://www.energyculture.com.au/solar-meeting-northern-beaches\n\nWe also wash our vans internally daily, wear gloves and face mask if needed and wash, wash wash out hands.",
    operatingHours: null,
    phoneNumber: "0299497552",
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.energyculture.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/5MSYxMaum2LJTEPK9",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/energynculture/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-energy-culture-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T10:31:24",
    email: "info@villagehomeandgifts.com.au",
    name: "Village Home & Gifts",
    address: "Shop 2/19-23 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "At Village Home & Gifts we passionately support small Australian brands, we specialise in unique lifestyle products, decorative homewares, wallpapers, all Australian designed jewellery & accessories. We provide free gift wrapping. FREE delivery for Northern Beaches customers.",
    currentSituationDescription:
      "Since closing our Manly shop front we are providing FREE local delivery and gift wrapping service for Northern Beaches customers. Simply shop online at www.villagehomeandgifts.com.au and select free delivery! Follow us on Instagram @villagehomeandgifts",
    operatingHours:
      "Our Manly store is closed but window shopping is free!! To buy goto www.villagehomeandgifts.com.au",
    phoneNumber: "0416276678",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.villagehomeandgifts.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/AUeM7An6rTQ6uMhy7",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/villagehomeandgifts/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/villagehomeandgifts",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-village-home-gifts-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-village-home-gifts-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T10:40:43",
    email: "orda.kora@bigpond.com",
    name: "Orda kora",
    address: "128 Beatrice St, Balgowlah Heights NSW 2093, Australia",
    category: "Retail",
    businessDescription:
      "Orda kora has been part of the balgowlahheights shopping village for over 20 years \nNot only gifts 🎁 we have great clothing jewelry and fashion accessories",
    currentSituationDescription:
      "Please follow me on instagram orda_kora for updates . we are open for any gift emergencies and happy to deliver to the local area \nThings to make you feel good",
    operatingHours: "We are open Monday - Saturday 9.30am-5.30pm",
    phoneNumber: "0299481385",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/SAcHJvM5Sm5wJZqS9",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/orda_kora/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-orda-kora-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T11:26:51",
    email: "sam@stenton.com.au",
    name: "Stenton Creed Pty Ltd",
    address: "PO Box 725, Manly 1655",
    category: "Trades and Services",
    businessDescription:
      "Stenton is a family run business. We represent retail tenants in lease negotiations with landlords. We are offering a free consultation in regards to COVID-19 and how it can impact your property discussions with your landlord.",
    currentSituationDescription:
      "Our retail brands we represent Australia wide have run out of cash to engage us in work",
    operatingHours: "Monday-Friday Office hours (9-5pm)",
    phoneNumber: "0403745699",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.stenton.com.au/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-stenton-creed-pty-ltd-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T11:37:07",
    email: "jane@savvygraphics.com.au",
    name: "Savvy Graphics",
    address: "3 Quinlan Parade Manly Vale NSW 2093 Australia",
    category: "Design and Architecture",
    businessDescription:
      "Savvy Graphics is a complete design studio specialising in print media and web. We particularly love magazines and long documents including annual reports, forms and T&Cs which many are happy to outsource. We can help get you ready to relaunch your business!",
    currentSituationDescription:
      "Down time can be a great productive time to work on your business. Time to review and consider refreshing your brand, collateral, promotional material and website, so when business takes off, faster than a speeding bullet, you are empowered and ready!",
    operatingHours: "10am-5pm Tuesday – Friday",
    phoneNumber: "0435085031",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://savvygraphics.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/c8w8NDozfXbBVyqL7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-savvy-graphics-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T11:39:11",
    email: "michael@groundzerocafemanly.com.au",
    name: "Ground Zero Cafe",
    address: "Shop 2/18 Sydney Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Early risers in search of breakfast will find options like bacon and egg rolls and breaky wraps with free coffee, vege options available and our full drinks menu is available",
    currentSituationDescription:
      "Ground Zero is operating  pick up only with a full drinks menu and limited breakfast menu",
    operatingHours:
      "Monday 8 - 2 Tuesday 8-2 Wednesday 8-2 Thursday 8-2 Friday 8-2 Saturday 8-2 Sunday 8-2",
    phoneNumber: "0299776996",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://groundzerocafemanly.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/D887RX3fqGKKtr6R6",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-ground-zero-cafe-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-ground-zero-cafe-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-ground-zero-cafe-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T12:12:09",
    email: "jenna@thefertilitysuite.com.au",
    name: "The Fertility Suite",
    address: "Suite 11/37-38 E Esplanade, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "We offer natural reproductive treatment and support, combining eastern and biomedical practices.",
    currentSituationDescription:
      "Telehealth fertility consultations, with contactless delivery of herbs abs supplements. \nLimited face to face consultations and treatments following extensive infection control guidelines are available.",
    operatingHours: "Currently by appointment only",
    phoneNumber: "0450218849",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.thefertilitysuite.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/tfs-manly?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/jenna_thefertilitysuite/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-fertility-suite-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T12:28:43",
    email: "info@henriettaskate.com.au",
    name: "Nine Lives Pty Ltd (Trading as Henrietta Skate)",
    address: "Shop 2/49-53 N Steyne, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription:
      "We are a skateboard and vintage clothing store based in Manly on Sydney's Northern Beaches. We focus on selling good quality products and supporting the local skate and arts community in the area.",
    currentSituationDescription:
      "Most of our general inquiries are being made over the phone or via email. Some things however such as repairs, try before you buy and one on one lessons are still running just in a controlled setting in accordance with current NSW restrictions.",
    operatingHours: "monday to friday - 11-6pm Saturday - Sunday 9-5pm",
    phoneNumber: "0425322117",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.henriettaskate.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/VFb6oikxYxBBciDn6",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/henriettaskate/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-henrietta-skate-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T13:14:30",
    email: "mina@minastaples.com",
    name: "Mina Staples Interiors",
    address: "1 Arthur St Fairlight NSW 2094 Australia",
    category: "Design and Architecture",
    businessDescription:
      "Intuitive residential interior designer, born from a curiosity of how diversely we all live, a passion for colour and a desire to help help.    I love to work collaboratively to create homes specifically tailored to ones lifestyle. I see interior design as 'space therapy' so to create harmonious interior flow throughout inside and out is vital to ensure quality of life is maximised. The final result; personalised spaces embedded with timeless comfort and charm. No job is too small, nor any question not important, they are all connectors that create a holistic story of your life within the walls.",
    currentSituationDescription:
      "I am providing online consultations at greatly reduced rates + am offering short live / online consultations.  30 min minimum pep talks, quick advice for people who need guidance or hot tips on ways to recreate their home offices, organise their life a little more efficiently or simply aiding to fix those issues that have been bugging people but they never had time to resolve but just dont know here to start!",
    operatingHours: null,
    phoneNumber: "0413629045",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.minastaples.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/TD5JUmaSkynE6Pe9A",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-mina-staples-interiors-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-mina-staples-interiors-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T14:37:24",
    email: "julija@tinkertank.rocks",
    name: "TINKERTANK",
    address: "1/29 Rialto Ln, Manly NSW 2095, Australia",
    category: "Education and Childcare",
    businessDescription:
      "Australia's original Tech-based Makerspace for all ages - now on-line!!",
    currentSituationDescription: "On-line",
    operatingHours:
      "5 days a week - On-line live streaming and courses and workshops on-line",
    phoneNumber: "1300670104",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.tinkertank.rocks/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/oruZcPc8pG2HQfwy8",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/pg/TinkerTankAU",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-tinkertank-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T16:20:03",
    email: "aliciangyutin@gmail.com",
    name: "Blue Afro hair skin & body",
    address: "22 Pittwater Rd, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "A creative, passionate duo that really cares about the final result they achieve for each and every client. Good hair good skin good vibes.",
    currentSituationDescription:
      "One client at a time one on one hair dressing appointments only. At home colour kits. Skin and hair products pick up/ delivery in Northern Beaches area. Instagram promotions possible virtual facial consultation.",
    operatingHours: "7 days a week by appointment",
    phoneNumber: "0299771979",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.blueafro.me/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/W5LRmYo4Tu6miYDh7",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-blue-afro-hair-skin-body-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T16:23:12",
    email: "enquiries@manlyapartments.com.au",
    name: "Manly Beach Holiday & Executive Apartmenta",
    address: "Suite 10/22 Central Ave, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      'Our apartments are officially "4 star rated" all have fully equipped kitchens,  balconies some with beach views',
    currentSituationDescription:
      "we have introduced enhanced techniques for cleaning of high touch areas.",
    operatingHours:
      "Office/reception is open 7 days  9am - 7pm (closed public holidays )",
    phoneNumber: "0299772444",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.manlyapartments.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/3wjnc6i9aDLyv6TA8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-beach-holiday-apartments-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T16:35:31",
    email: "kirsty@fivestarhr.com.au",
    name: "Five Star HR",
    address: "47 Southern Cross Way, Allambie Heights NSW 2100 Australia",
    category: "Trades and Services",
    businessDescription:
      "Five Star HR is a locally based HR consulting and coaching practice that partners with businesses to help them get the most from their people.",
    currentSituationDescription:
      "I am working remotely from home and can be available for online/virtual or telephone consultations.  I provide HR advice and support for small businesses with everything related to their employees - employee relations, recruitment and retention, performance management, policy development, industrial relations, compliance, etc.  I am able to offer a complimentary 30 minute consult to any small business owner that needs help working out their options in relation to managing their employees during this tumultuous time.",
    operatingHours:
      "Mon-Fri (9-6pm) - although responsive to urgent enquiries after hours",
    phoneNumber: "0422634359",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://fivestarhr.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/eduAgZNRD4iP4zNo9",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-five-star-hr-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T16:45:04",
    email: "fika@swedishkitchen.com.au",
    name: "Fika Swedish Kitchen",
    address: "5B Market Pl, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Tucked away in one of Manly's laneways, Fika Swedish Kitchen is bringing the famous Swedish Coffee culture ’Fika’ down under. With a menu ranging from Swedish Meatballs & Toast Skagen to Cinnamon buns & Swedish brew, this eatery quickly became Sydney’s ultimate Swedish foodie experience.",
    currentSituationDescription:
      "We are open for takeaway and we deliver to anyone living in the Manly area (postcode 2093-2096).",
    operatingHours: "7am-2pm everyday",
    phoneNumber: "0299765099",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.fikaswedishkitchen.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/pwXV8Ka53Tjp5cVk6",
        text: null,
      },
      {
        type: "Instagram",
        url: "http://instagram.com/fikabondi",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-fika-swedish-kitchen-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T16:48:40",
    email: "info@theartisancheeseroom.com.au",
    name: "The Artisan Cheese Room",
    address: "1/40 E Esplanade, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "The Artisan Cheese Room is a cheese lovers paradise. We source the world’s finest cheeses and accompaniments with a focus on unique, small batch and seasonal produce. We also offer perfectly paired wines, beers and gins to provide a unique tasting experience.",
    currentSituationDescription:
      "Our shop remains open -  but we’re also offering free local delivery to Manly and surrounds. Our deliveries include an array of International and Aussie cheeses as well as Platters, Gift Hampers and Grazing Boxes. Our Hampers make great gifts too and we can also supply and deliver perfectly paired wines, beers and gins too!",
    operatingHours:
      "Mon - Closed\nTues - 10-5\nWeds 10-5\nThu 10-5\nFri 10-5\nSat 10-5\nSun 10-4",
    phoneNumber: "0448801905",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://theartisancheeseroom.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/The+Artisan+Cheese+Room/@-33.7998082,151.2833453,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0936663f0b:0x1f7e53f07d6ef780!8m2!3d-33.7998082!4d151.285534",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-artisan-cheese-room-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-the-artisan-cheese-room-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T17:02:08",
    email: "balgowlahheightsdeli@hotmail.com",
    name: "Balgowlah Heights Deli",
    address: "2093/122 Beatrice St, Balgowlah Heights NSW 2093, Australia",
    category: "Food and Drink",
    businessDescription:
      "We are a family operated business that are passionate about great food and coffee. We prepare all of our food on site, including lasagnas, pasta sauces, salads, arancini amd more. We also have a fabulous assortment of cheeses, charcuterie and antipasto.",
    currentSituationDescription: "We are takeaway only.",
    operatingHours:
      "Monday 6am to 6pm Tuesday 6am to 6pm Wednesday 6am to 6pm Thursday 6am to 6pm Friday 6am to 6pm Saturday 6am to 6pmSunday 6am to 3pm",
    phoneNumber: "0299493969",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Balgowlah+Heights+Deli/@-33.8010442,151.2552647,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab952d89d69b:0xdbf83b1abdbad065!8m2!3d-33.8010442!4d151.2574534",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/balgowlahheightsdeli/",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/Balgowlah-Heights-Deli-237547416940/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-balgowlah-heights-deli-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T18:22:01",
    email: "manly.beach.babes@hotmail.com",
    name: "Manly Beach Babes",
    address: "Shop 4/22A Darley Rd, Manly NSW 2095, Australia",
    category: "Retail",
    businessDescription: "Baby & childrenswear wear  retail",
    currentSituationDescription:
      "Online sales are delivered for free in Oz & localally delivered free & within 24hours",
    operatingHours: "Changes all the time 11-2 most days",
    phoneNumber: "0402346308",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://manlybeachbabes.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Manly+Beach+Babes/@-33.7999167,151.2850332,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f2282e11b:0xfde88e7e44a7fe7d!8m2!3d-33.7999167!4d151.2872219",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-beach-babes-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T19:26:12",
    email: "mason.dalili@servistar.com.au",
    name: "Servistar",
    address: "29 Howard Avenue, Dee Why NSW 2099, Australia",
    category: "Trades and Services",
    businessDescription:
      "We are a Local online market place connecting car owners to Local Mechanics.",
    currentSituationDescription:
      "We are offering Free pick up and drop off , free car wash & clean + Complimentary Sanitization and Disinfectant treatment after Car Service.",
    operatingHours: "7am- 7pm",
    phoneNumber: "1300352262",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.servistar.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/29+Howard+Ave,+Dee+Why+NSW+2099/@-33.7531194,151.286803,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa8455f36f99:0x2ba64cbc9a34430a!8m2!3d-33.7531194!4d151.2889917",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-servistar-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-servistar-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T21:11:36",
    email: "manly.art.framing@gmail.com",
    name: "MAF / Manly Art & Framing",
    address: "3 Market Ln, Manly NSW 2095, Australia",
    category: "Trades and Services",
    businessDescription:
      "Custom picture framers, dedicated to modern framing with selection of unique and handmade homewares.",
    currentSituationDescription:
      "Luckily we are still trading but operating on a smaller scale. Shorter opening hours (9 till 4pm) and closed on Sundays and Mondays. During this time when we are mostly at home its important to surround ourselves with beautiful art or photographs that will make our hearts warm.",
    operatingHours: "Tuesday to Saturday 9am - 4pm\nSundays and Mondays Closed",
    phoneNumber: "0299778262",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/MAF+%2F+Manly+Art+%26+Framing/@-33.7973615,151.2837461,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab0f4a7b9de1:0x63a64fb81e418f77!8m2!3d-33.7973615!4d151.2859348",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/manlyartframing/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-art-framing-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-07T21:49:00",
    email: "healthyheights2017@gmail.com",
    name: "Healthy Heights Apothecary, Supplements and Health Food",
    address: "71 New St W, Balgowlah Heights NSW 2093, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Created to provide trustworthy advice and information with regard to health issues from a natural perspective utilising an evidence based approach",
    currentSituationDescription:
      "Online consultations which are offered with no charge at the moment",
    operatingHours: "Monday - Friday 9am - 5pm",
    phoneNumber: "0299486600",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.healthyheights.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Healthy+Heights+Naturopathic+Apothecary/@-33.8006179,151.2550011,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12ab9363b1dd09:0x2969962154232490!8m2!3d-33.8006179!4d151.2571898",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-healthy-heights-apothecary-supplements-and-health-food-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T09:50:06",
    email: "office@exclusivetiles.com.au",
    name: "EXCLUSIVE TILES PTY LTD",
    address: "77 Winbourne Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription:
      "WE ARE A LOCALLY OWNED AND OPERATED FAMILY BUSINESS OF 30 YEARS\nYOUR ONE STOP SHOP ,OFFERING DESIGN AND SUPPLY OF ALL YOUR TILING NEEDS .wE ALSO HAVE QUALIFIED TRADESMAN FOR ALL BATHROOM ,OUTDOOR AND OTHER RENOVATIONS",
    currentSituationDescription:
      "SHOWROOM OPEN 6 DAYS FROM 6AM TIL 4PM FOR TRADE AND GENERAL PUBLIC ADHERING TO SOCIAL DISTANCING REQUIREMENTS AT ALL TIMES",
    operatingHours: "Monday to Friday 6am - 4pm\nSaturday 8am - 4pm",
    phoneNumber: "0291884041",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "http://www.exclusivetiles.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/tDG6NnXfL4qnS2xf8",
        text: null,
      },
    ],
    images: null,
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T09:52:03",
    email: "sam@sjdwine.com.au",
    name: "s j d Wine",
    address: "40 Crown Road, Queenscliff NSW 2096 Australia",
    category: "Food and Drink",
    businessDescription:
      "We are bringing the wine from the vineyard straight to your door. Hand selected by the wine maker himself.",
    currentSituationDescription:
      "We are offering FREE WINE DELIVERY and are online only",
    operatingHours: "24-7 available. No weekend deliveries",
    phoneNumber: "0403675842",
    pickup: false,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.sjdwine.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/qqQbySpQSTd5Ydq5A",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/sjdwines/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-s-j-d-wine-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T10:04:56",
    email: "moncab3@hotmail.com",
    name: "Manly Deli",
    address: "37 Sydney Rd, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "Not your average Deli located in the heart of Manly on Sydney Road. Great coffee, delicious and very affordable food and easy take home meals! Manly Deli has been a statement piece in Manly for the past 70 years, missing its locals more than ever.",
    currentSituationDescription:
      "Currently providing takeaway only to customers, from breakfast deals to sandwiches with whatever you'd like, coffee, salads, pastas, lasagnas etc. Easy meals to take home and heat up/ toast or save for breakfast lunch or dinner!",
    operatingHours:
      "Monday 7am-3pm\nTuesday 7am-3pm\nWednesday 7am-3pm\nThursday 7am-3pm\nFriday 7am-3pm\nSaturday 7am-3pm\nSunday 7am-3pm",
    phoneNumber: "0412223982",
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/VMBsL2dH3oWshTa27",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-deli-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T10:18:45",
    email: "rachel@3pointcapital.com",
    name: "3 Point Capital",
    address: "Suite 9/226 Condamine St, Manly Vale NSW 2093, Australia",
    category: "Trades and Services",
    businessDescription:
      "3 Point Capital is a private lender specialising in helping individuals and businesses access residential, investment and commercial loans and investment. We have access to over 60 lenders including offshore lenders to get the most competitive rates.",
    currentSituationDescription:
      "We are connecting via zoom  video conference if people are at home or via phone call",
    operatingHours: "Monday to Friday",
    phoneNumber: "432765156",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.3pointcapital.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/3-point-capital?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-3-point-capital-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T12:08:07",
    email: "marketing@manlyfoodcoop.org",
    name: "Manly Food Co-op",
    address: "Lot 1/11-25 Wentworth St, Manly NSW 2095, Australia",
    category: "Food and Drink",
    businessDescription:
      "A place where you’ll find fresh organic fruit and vegetables, bulk wholefoods, pantry and household staples. We are not your typical grocery store. We are owned and operated by our members and open to everyone. The majority of our products are packaging-free.",
    currentSituationDescription:
      "We had to change our business model within a week, going from a normal operated shop towards online ordering and pick up only. Due to the new business model we have less",
    operatingHours:
      "Our opening hours have changed: We are open every day from 9am to 4pm",
    phoneNumber: null,
    pickup: true,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://manlyfoodcoop.org/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/ManlyFoodCoOp?share",
        text: null,
      },
      {
        type: "CallToAction",
        url: "https://mfcapp.org/",
        text: "Order Online",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-food-coop-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-food-coop-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-food-coop-3.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-food-coop-4.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-food-coop-5.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T14:54:44",
    email: "hello@theyachtlife.com.au",
    name: "The Yacht Life",
    address: "40 Crown Road, Queenscliff NSW 2096 Australia",
    category: "Adventure, Travel and Tourism",
    businessDescription:
      "The Yacht Life specialises in finding you the right yacht for your special charter experience. By having access to every yacht world wide and our expert knowledge you will feel at ease when creating your dream event or itinerary with us. We are here to plan something to look forward to. We are ready when you are",
    currentSituationDescription:
      "We are taking the time to connect with people to plan for something to look forward to wether that be a product launch, special milestone, Christmas party or a luxury experience on board your private SuperYacht.",
    operatingHours: "Open 24 hours, 7 days per week",
    phoneNumber: "0403675842",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.theyachtlife.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/preAKbCspkna3q3L6",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-yacht-life-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T16:06:40",
    email: "nick@thefootballstreet.com",
    name: "The Football Street",
    address: "14 West St, Brookvale NSW 2100, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "At The Football Street we want players to have fun, make their own decisions and learn. The best players learned how to play football on the street and that's what we want to allow, a balance of good coaching and free play to allow players to develop as much as they want to.",
    currentSituationDescription:
      "We are an indoor football centre, so have had to close our doors due to COVID-19. We are now offering 1 on 1 coaching over video calls and offering a membership to an online community where members can access webinars and Q&A with coaches on a weekly basis.",
    operatingHours:
      "Monday 9am - 6pm\nTuesday 9am - 6pm\nWednesday 9am - 6pm\nThursday 9am - 6pm\nFriday 9am - 6pm\nSaturday 9am - 6pm",
    phoneNumber: "0401300901",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.thefootballstreet.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/thefootballstr?share",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-the-football-street-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T16:07:14",
    email: "ssmithies@visionpt.com.au",
    name: "Vision PT Brookvale",
    address: "577 Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "With a desire to offer a completely personalised and tailored approach to all Our clients, we can assure them they are getting specific program to their current situation and goals",
    currentSituationDescription:
      "We are offering 1on1 outdoor and online PT as well as live online group PT",
    operatingHours: "5.30am - 7pm",
    phoneNumber: "0401785113",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.visionpt.com.au/studios/brookvale",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/quQkEUS6ks1ZHV2Y8",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/vision_personal_training/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-vision-pt-brookvale-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T17:33:39",
    email: "brookvale@globalstorage.com.au",
    name: "Global Self Storage Brookvale Pty Ltd",
    address: "8 Clearview Pl, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription: "Self Storage of your goods. Personal and Business",
    currentSituationDescription:
      "We're open, we're competitive and we're here to help in genuine need",
    operatingHours: "Monday to Saturday 8am to 5pm \nSunday 10am to 4pm",
    phoneNumber: "0299058655",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "http://www.globalstorage.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/Wj757dPQz45J4NAs8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-global-self-storage-brookvale-pty-ltd-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T20:11:30",
    email: "espressoseaforth@gmail.com",
    name: "Espresso Seaforth",
    address: "Shop 2/565 Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Food and Drink",
    businessDescription:
      "Locally roasted coffee and produce are our passion for serving with a smile.",
    currentSituationDescription:
      "Take away only or home delivery via UberEats.",
    operatingHours: "Monday to Friday 7am to 4pm\nSaturday & Sunday 8am to 3pm",
    phoneNumber: "0299077754",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.espressoseaforth.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/GcVeaQHD3gCtuBFy8",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-espresso-seaforth-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-08T20:23:45",
    email: "andrew@northheadfitness.com.au",
    name: "North Head Fitness",
    address: "61 North Fort Road, Manly NSW 2095, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "North Head Fitness is a gym like no other: not only for our huge variety of classes and community environment, but also our location in the grounds of the North Head Sanctuary, just up the hill from the heart of Manly. We've been open for over 7 years, and our usual timetable includes CrossFit, Barbell, Endurance, Boxing, CrossFit Kids and Kids/Teens Muay Thai classes. Visit us for a free trial class once we've re-opened!",
    currentSituationDescription:
      "With our gym closed, we are now operating 2 online only programs for our members: one that requires basic equipment (eg. dumbbell or kettlebell only) and one that is bodyweight only (no equipment required) for only $15 per week. We're also running Zoom classes at 6:30am, 9:30am and 5:00pm Monday to Friday, and are planning a special membership offer when we are able to re-open.",
    operatingHours:
      "Our gym is closed, however we're running daily Zoom workouts for members at 6:30am, 9:30am & 5:00pm. Plus our Friday 5:00pm class tends to finish with a virtual drink!",
    phoneNumber: "0411063903",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://northheadfitness.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/north-head-fitness-manly?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/northheadfitness/",
        text: null,
      },
    ],
    images: null,
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T07:52:28",
    email: "courtney@modernmovement.com.au",
    name: "Modern Movement",
    address: "Level1/2 Paton Pl, Fairlight NSW 2094, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "The vision Modern Movement is yoga with purpose. We blend the best of where we’ve been, with the intelligence and potential of where we’re going. That’s why we offer more than just traditional yoga. You’ll find styles suited to every body at any stage of experience, ranging from Pilates to Yin.\nWe believe in the power of community and since 2015 have been offering a place for people to connect on and off the mat.",
    currentSituationDescription:
      "While we had to close the doors to our physical studio we have opened our virtual studio which is providing 5 live streamed classes for day and a wealth of on demand options. All with some of the best teachers on the northern beaches.",
    operatingHours:
      "Live streaming 5 classes all day every day and a wealth of on demand options.",
    phoneNumber: null,
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://modernmovement.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://goo.gl/maps/ragQCLVF9KnKQQgo9",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/modernmovementyoga/",
        text: null,
      },
      {
        type: "CallToAction",
        url: "mailto:hello@modernmovement.com.au",
        text: "Email Us",
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-modern-movement-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-modern-movement-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T09:01:45",
    email: "yvette@seaforthphysio.com",
    name: "Seaforth Physiotherapy & Sports Injury Centre",
    address: "6/567 Sydney Rd, Seaforth NSW 2092",
    category: "Health, Beauty and Fitness",
    businessDescription:
      "Having provided quality physiotherapy services to the local community for over 17 years, we will continue to do so during this COVID-19 period. Caring, professional and hygienic practice.",
    currentSituationDescription:
      "During this COVID time, Seaforth Physiotherapy continues to offer treatment for those people with musculoskeletal pain in the practice. Extra precautions in place for both staff and clients. For the vulnerable, we are offering a more extensive home visit service and exercise physiology services all 1 on 1. Online exercise classes available for rehab, strength & conditioning and core strength. Telehealth appointments also available if unable or uncomfortable coming into the practice.",
    operatingHours:
      "Monday: 7:30am - 7:00pm\nTuesday: 7:30am - 7:00pm\nWednesday: 7:30am - 7:00pm\nThursday: 7:30am - 7:00pm\nFriday: 7:30am - 7:00pm\nSaturday: 8am - 12pm",
    phoneNumber: "0299497651",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://seaforthphysio.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/seaforthphysio?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/seaforthphysio/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-seaforth-physiotherapy-sports-injury-centre-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T09:05:22",
    email: "info@camerahire.com.au",
    name: "Camera Hire",
    address: "Unit 8/111 Old Pittwater Rd, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription:
      "Camera Hire provides photography, video, lighting and studio hire to local industry.",
    currentSituationDescription: "Pick up as well as delivery available",
    operatingHours:
      "Monday: 8am-6pm\nTuesday: 8am-6pm\nWednesday: 8am-6pm\nThursday: 8am-6pm\nFriday: 8am-6pm\nSaturday: Closed\nSunday: Closed",
    phoneNumber: "0280658195",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.camerahire.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url: "https://g.page/camerahireaustralia?share",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/camerahire/",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-camera-hire-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T10:03:55",
    email: "hello@stowawaybar.com",
    name: "Stowaway Bar",
    address: "Shop 18/1-3 Moore Rd, Freshwater NSW 2096, Australia",
    category: "Food and Drink",
    businessDescription:
      "We are Freshy’s first local neighbourhood bar serving up dude food, cocktails, cracking wine & cold beer.",
    currentSituationDescription:
      "The physical venue is closed but we our delivery spirits are high!",
    operatingHours: "Open midday 7 days a week (til late)",
    phoneNumber: "0299391171",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.stowawaybar.com/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Stowaway+Bar/@-33.7788846,151.2834794,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aaf91676a147:0x1b4ef73f1a9d2153!8m2!3d-33.7788891!4d151.2856734",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-stowaway-bar-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-stowaway-bar-2.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-stowaway-bar-3.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T14:07:17",
    email: "karen@undergroundcomms.com.au",
    name: "Underground Communications",
    address: "G02/385 Sydney Rd, Balgowlah NSW 2093, Australia",
    category: "Advertising, Arts & Media",
    businessDescription:
      "With community at the heart of our values, we work collaboratively with clients to develop and implement integrated communication strategies that share brand stories, successes and impact. We love companies that are here for the greater good who can be an inspiration and a beacon to do business better.",
    currentSituationDescription:
      "With remote working capabilities in place our team has seamlessly transitioned to work from home mode without missing a beat, allowing us to continue to share our clients' stories of positive social impact and the innovation they've been forced to implement during the COVID-19 crisis.",
    operatingHours: "Monday - Friday 9am-5pm",
    phoneNumber: "0280658827",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://undergroundcomms.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Underground+Communications/@-33.7945445,151.261766,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa20399435f7:0xe11afe22c8820ee7!8m2!3d-33.794549!4d151.26396",
        text: null,
      },
      {
        type: "Instagram",
        url: "https://www.instagram.com/undergroundcomms/",
        text: null,
      },
      {
        type: "LinkedIn",
        url: "https://www.linkedin.com/company/underground-communications/",
        text: null,
      },
      {
        type: "Twitter",
        url: "https://twitter.com/u_groundcomms",
        text: null,
      },
      {
        type: "Facebook",
        url: "https://www.facebook.com/undergroundcomms",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-underground-communications-1.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T14:37:17",
    email: "bauhaushd@gmail.com",
    name: "Bauhaus Hair Design",
    address: "537a Sydney Rd, Seaforth NSW 2092, Australia",
    category: "Health, Beauty and Fitness",
    businessDescription: null,
    currentSituationDescription:
      "We are operating as usual with minimal staff and limited hours. Taking all precautions to keep our staff and clients safe and healthy.",
    operatingHours: "By Appointment",
    phoneNumber: "0299494107",
    pickup: false,
    delivery: false,
    websites: [
      {
        type: "Website",
        url: "https://www.bauhaushd.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Bauhaus+Hair+Design/@-33.796785,151.2497505,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12abe9e7080f27:0x766eb61b9f772895!8m2!3d-33.7967895!4d151.2519445",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-bauhaus-hair-design-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-bauhaus-hair-design-2.jpg",
    ],
    group: "manly",
  },
  {
    timeStamp: "2020-04-09T16:04:13",
    email: "accounts@bigchiefremovals.com.au",
    name: "Big Chief Removals",
    address: "8 Clearview Pl, Brookvale NSW 2100, Australia",
    category: "Trades and Services",
    businessDescription: "We are a furniture removals and delivery service",
    currentSituationDescription:
      "All staff are following hygiene procedures recommended by the government.",
    operatingHours: "Now open 7 days to help as many people possible",
    phoneNumber: "0402744009",
    pickup: true,
    delivery: true,
    websites: [
      {
        type: "Website",
        url: "https://www.bigchiefremovals.com.au/",
        text: null,
      },
      {
        type: "GoogleMapsLink",
        url:
          "https://www.google.com/maps/place/Big+Chief+Removals+Pty+Ltd/@-33.7618865,151.259466,17z/data=!3m1!4b1!4m5!3m4!1s0x6b12aa84af3e9e8b:0x1c22879da13fe82!8m2!3d-33.761891!4d151.26166",
        text: null,
      },
    ],
    images: [
      "https://data.backyourlocal.com.au/assets/business-manly-big-chief-removals-1.jpg",
      "https://data.backyourlocal.com.au/assets/business-manly-big-chief-removals-2.jpg",
    ],
    group: "manly",
  },
];
